/* tslint:disable */
import globalAxios from 'axios';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, createRequestFunction, serializeDataIfNeeded, setApiKeyToObject, setSearchParams, toPathString, } from './common';
export const CrmServiceDomainModelDealsheetProposalDisplayModeEnum = {
    Default: 'DEFAULT',
    OmitNoCurrentPrice: 'OMIT_NO_CURRENT_PRICE',
    SourgumRatesOnly: 'SOURGUM_RATES_ONLY',
};
export const CrmServiceDomainModelDealsheetSavingsBasisEnum = {
    Contracted: 'CONTRACTED',
    FullyLoaded: 'FULLY_LOADED',
    EffectiveSpend: 'EFFECTIVE_SPEND',
};
export const ModelBusinessCategory = {
    BusinessCategoryGeneralContractors: 'generalContractors',
    BusinessCategoryHomebuilders: 'homebuilders',
    BusinessCategoryRoofingCompanies: 'roofingCompanies',
    BusinessCategoryDemolitionContractors: 'demolitionContractors',
    BusinessCategoryLandscapingHardscaping: 'landscapingHardscaping',
    BusinessCategoryRemodelingRenovation: 'remodelingRenovation',
    BusinessCategoryMasonryConcrete: 'masonryConcrete',
    BusinessCategoryManufacturingPlants: 'manufacturingPlants',
    BusinessCategoryWarehousesDistribution: 'warehousesDistribution',
    BusinessCategoryAutomotiveRepairShops: 'automotiveRepairShops',
    BusinessCategoryRetailStores: 'retailStores',
    BusinessCategoryRestaurants: 'restaurants',
    BusinessCategoryOfficeBuildings: 'officeBuildings',
    BusinessCategoryPropertyManagementCompanies: 'propertyManagementCompanies',
    BusinessCategoryApartmentComplexes: 'apartmentComplexes',
    BusinessCategoryRealtorsPreSaleCleanouts: 'realtorsPreSaleCleanouts',
    BusinessCategoryStorageFacilities: 'storageFacilities',
    BusinessCategorySchoolsCollegesUniversities: 'schoolsCollegesUniversities',
    BusinessCategoryHospitalsMedicalCenters: 'hospitalsMedicalCenters',
    BusinessCategoryGovernmentBuildings: 'governmentBuildings',
    BusinessCategoryParksRecreation: 'parksRecreation',
    BusinessCategoryPublicWorks: 'publicWorks',
    BusinessCategoryJunkRemovalCompanies: 'junkRemovalCompanies',
    BusinessCategoryEventOrganizers: 'eventOrganizers',
    BusinessCategoryDisasterCleanupRestoration: 'disasterCleanupRestoration',
    BusinessCategoryHomeCleanouts: 'homeCleanouts',
    BusinessCategoryDiyRenovationProjects: 'diyRenovationProjects',
    BusinessCategoryMajorLandscapingProjects: 'majorLandscapingProjects',
};
export const ModelEquipmentServiceRentalFrequencyUnitEnum = {
    Month: 'MONTH',
    Purchase: 'PURCHASE',
};
export const ModelIssueStatusEnum = {
    IssueStatusOpen: 'OPEN',
    IssueStatusResolved: 'RESOLVED',
};
export const ModelRFPStatusEnum = {
    RFPStatusPendingResponse: 'PENDING_RESPONSE',
    RFPStatusResponseAvailable: 'RESPONSE_AVAILABLE',
    RFPStatusSpecsDiffer: 'SPECS_DIFFER',
    RFPStatusDeclinedToQuote: 'DECLINED_TO_QUOTE',
    RFPStatusQuoted: 'QUOTED',
    RFPStatusClosedWon: 'CLOSED_WON',
    RFPStatusClosedLost: 'CLOSED_LOST',
    RFPStatusPartiallyWon: 'PARTIALLY_WON',
    RFPStatusSubscription: 'SUBSCRIPTION',
    RFPStatusReQuote: 'RE_QUOTE',
    RFPStatusLoa: 'LOA',
    RFPStatusAwarded: 'AWARDED',
};
export const ModelRollOffServicePricingTypeEnum = {
    Ton: 'ton',
    Yard: 'yard',
    Flat: 'flat',
};
export const ModelServiceStatusEnum = {
    ServiceStatusMoreInfoNeeded: 'MORE_INFO_NEEDED',
    ServiceStatusNeedsReview: 'NEEDS_REVIEW',
    ServiceStatusReadyToQuote: 'READY_TO_QUOTE',
    ServiceStatusQuoted: 'QUOTED',
    ServiceStatusLoa: 'LOA',
    ServiceStatusPendingResponse: 'PENDING_RESPONSE',
    ServiceStatusResponseAvailable: 'RESPONSE_AVAILABLE',
    ServiceStatusSpecsDiffer: 'SPECS_DIFFER',
    ServiceStatusDeclinedToQuote: 'DECLINED_TO_QUOTE',
    ServiceStatusClosedWon: 'CLOSED_WON',
    ServiceStatusClosedLost: 'CLOSED_LOST',
    ServiceStatusPartiallyWon: 'PARTIALLY_WON',
    ServiceStatusSubscription: 'SUBSCRIPTION',
    ServiceStatusReQuote: 'RE_QUOTE',
    ServiceStatusAwarded: 'AWARDED',
};
export const ModelSiteStatusEnum = {
    SiteStatusMoreInfoNeeded: 'MORE_INFO_NEEDED',
    SiteStatusNeedsReview: 'NEEDS_REVIEW',
    SiteStatusReadyToQuote: 'READY_TO_QUOTE',
    SiteStatusQuoted: 'QUOTED',
    SiteStatusLoa: 'LOA',
    SiteStatusReQuote: 'RE_QUOTE',
    SiteStatusClosedWon: 'CLOSED_WON',
    SiteStatusClosedLost: 'CLOSED_LOST',
    SiteStatusAwarded: 'AWARDED',
    SiteStatusDoNotService: 'DO_NOT_SERVICE',
};
export const RolloffserviceWithRatesPricingTypeEnum = {
    Ton: 'ton',
    Yard: 'yard',
    Flat: 'flat',
};
/**
 * CommercialServicesApi - axios parameter creator
 */
export const CommercialServicesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all dealsheet commercial services with optional filtering and sorting
         * @summary List all dealsheet commercial services
         * @param {string} [id] Filter by dealsheet commercial service ID
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {string} [siteID] Filter by site ID (returns only services NOT associated with RFPs)
         * @param {string} [siteIDWithRFP] Filter by site ID (returns only services associated with RFPs)
         * @param {string} [rfpSiteID] Filter by RFP site ID
         * @param {string} [status] Filter by status
         * @param {string} [vendorID] Filter by vendor ID
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1DealsheetCommercialServicesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetCommercialServicesGet: async (id, dealsheetID, siteID, siteIDWithRFP, rfpSiteID, status, vendorID, sortBy, sortDir, limit, offset, options = {}) => {
            const localVarPath = `/crm/v1/dealsheet-commercial-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (dealsheetID !== undefined) {
                localVarQueryParameter['dealsheetID'] = dealsheetID;
            }
            if (siteID !== undefined) {
                localVarQueryParameter['siteID'] = siteID;
            }
            if (siteIDWithRFP !== undefined) {
                localVarQueryParameter['siteIDWithRFP'] = siteIDWithRFP;
            }
            if (rfpSiteID !== undefined) {
                localVarQueryParameter['rfpSiteID'] = rfpSiteID;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (vendorID !== undefined) {
                localVarQueryParameter['vendorID'] = vendorID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete a dealsheet commercial service by its ID
         * @summary delete a dealsheet commercial service
         * @param {string} id Dealsheet Commercial Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetCommercialServicesIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetCommercialServicesIdDelete', 'id', id);
            const localVarPath = `/crm/v1/dealsheet-commercial-services/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a copy of an existing commercial service including all order items with their values. The duplicated service will be on the same site as the source.
         * @summary Duplicate a commercial service with all order items
         * @param {string} id Source Commercial Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetCommercialServicesIdDuplicatePost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetCommercialServicesIdDuplicatePost', 'id', id);
            const localVarPath = `/crm/v1/dealsheet-commercial-services/{id}/duplicate`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing dealsheet commercial service with the provided data
         * @summary update a dealsheet commercial service
         * @param {string} id Dealsheet Commercial Service ID
         * @param {ModelCommService} commercialService Dealsheet Commercial Service object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetCommercialServicesIdPut: async (id, commercialService, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetCommercialServicesIdPut', 'id', id);
            // verify required parameter 'commercialService' is not null or undefined
            assertParamExists('crmV1DealsheetCommercialServicesIdPut', 'commercialService', commercialService);
            const localVarPath = `/crm/v1/dealsheet-commercial-services/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(commercialService, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new dealsheet commercial service
         * @summary create dealsheet commercial service
         * @param {ModelCommService} commercialService Dealsheet Commercial Service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetCommercialServicesPost: async (commercialService, options = {}) => {
            // verify required parameter 'commercialService' is not null or undefined
            assertParamExists('crmV1DealsheetCommercialServicesPost', 'commercialService', commercialService);
            const localVarPath = `/crm/v1/dealsheet-commercial-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(commercialService, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CommercialServicesApi - functional programming interface
 */
export const CommercialServicesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CommercialServicesApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all dealsheet commercial services with optional filtering and sorting
         * @summary List all dealsheet commercial services
         * @param {string} [id] Filter by dealsheet commercial service ID
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {string} [siteID] Filter by site ID (returns only services NOT associated with RFPs)
         * @param {string} [siteIDWithRFP] Filter by site ID (returns only services associated with RFPs)
         * @param {string} [rfpSiteID] Filter by RFP site ID
         * @param {string} [status] Filter by status
         * @param {string} [vendorID] Filter by vendor ID
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1DealsheetCommercialServicesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetCommercialServicesGet(id, dealsheetID, siteID, siteIDWithRFP, rfpSiteID, status, vendorID, sortBy, sortDir, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetCommercialServicesGet(id, dealsheetID, siteID, siteIDWithRFP, rfpSiteID, status, vendorID, sortBy, sortDir, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommercialServicesApi.crmV1DealsheetCommercialServicesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete a dealsheet commercial service by its ID
         * @summary delete a dealsheet commercial service
         * @param {string} id Dealsheet Commercial Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetCommercialServicesIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetCommercialServicesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommercialServicesApi.crmV1DealsheetCommercialServicesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a copy of an existing commercial service including all order items with their values. The duplicated service will be on the same site as the source.
         * @summary Duplicate a commercial service with all order items
         * @param {string} id Source Commercial Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetCommercialServicesIdDuplicatePost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetCommercialServicesIdDuplicatePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommercialServicesApi.crmV1DealsheetCommercialServicesIdDuplicatePost']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing dealsheet commercial service with the provided data
         * @summary update a dealsheet commercial service
         * @param {string} id Dealsheet Commercial Service ID
         * @param {ModelCommService} commercialService Dealsheet Commercial Service object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetCommercialServicesIdPut(id, commercialService, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetCommercialServicesIdPut(id, commercialService, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommercialServicesApi.crmV1DealsheetCommercialServicesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new dealsheet commercial service
         * @summary create dealsheet commercial service
         * @param {ModelCommService} commercialService Dealsheet Commercial Service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetCommercialServicesPost(commercialService, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetCommercialServicesPost(commercialService, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommercialServicesApi.crmV1DealsheetCommercialServicesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CommercialServicesApi - factory interface
 */
export const CommercialServicesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CommercialServicesApiFp(configuration);
    return {
        /**
         * Get all dealsheet commercial services with optional filtering and sorting
         * @summary List all dealsheet commercial services
         * @param {CommercialServicesApiCrmV1DealsheetCommercialServicesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetCommercialServicesGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1DealsheetCommercialServicesGet(requestParameters.id, requestParameters.dealsheetID, requestParameters.siteID, requestParameters.siteIDWithRFP, requestParameters.rfpSiteID, requestParameters.status, requestParameters.vendorID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.limit, requestParameters.offset, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * delete a dealsheet commercial service by its ID
         * @summary delete a dealsheet commercial service
         * @param {CommercialServicesApiCrmV1DealsheetCommercialServicesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetCommercialServicesIdDelete(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetCommercialServicesIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Creates a copy of an existing commercial service including all order items with their values. The duplicated service will be on the same site as the source.
         * @summary Duplicate a commercial service with all order items
         * @param {CommercialServicesApiCrmV1DealsheetCommercialServicesIdDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetCommercialServicesIdDuplicatePost(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetCommercialServicesIdDuplicatePost(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * update an existing dealsheet commercial service with the provided data
         * @summary update a dealsheet commercial service
         * @param {CommercialServicesApiCrmV1DealsheetCommercialServicesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetCommercialServicesIdPut(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetCommercialServicesIdPut(requestParameters.id, requestParameters.commercialService, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new dealsheet commercial service
         * @summary create dealsheet commercial service
         * @param {CommercialServicesApiCrmV1DealsheetCommercialServicesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetCommercialServicesPost(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetCommercialServicesPost(requestParameters.commercialService, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * CommercialServicesApi - object-oriented interface
 */
export class CommercialServicesApi extends BaseAPI {
    /**
     * Get all dealsheet commercial services with optional filtering and sorting
     * @summary List all dealsheet commercial services
     * @param {CommercialServicesApiCrmV1DealsheetCommercialServicesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetCommercialServicesGet(requestParameters = {}, options) {
        return CommercialServicesApiFp(this.configuration)
            .crmV1DealsheetCommercialServicesGet(requestParameters.id, requestParameters.dealsheetID, requestParameters.siteID, requestParameters.siteIDWithRFP, requestParameters.rfpSiteID, requestParameters.status, requestParameters.vendorID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.limit, requestParameters.offset, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete a dealsheet commercial service by its ID
     * @summary delete a dealsheet commercial service
     * @param {CommercialServicesApiCrmV1DealsheetCommercialServicesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetCommercialServicesIdDelete(requestParameters, options) {
        return CommercialServicesApiFp(this.configuration)
            .crmV1DealsheetCommercialServicesIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a copy of an existing commercial service including all order items with their values. The duplicated service will be on the same site as the source.
     * @summary Duplicate a commercial service with all order items
     * @param {CommercialServicesApiCrmV1DealsheetCommercialServicesIdDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetCommercialServicesIdDuplicatePost(requestParameters, options) {
        return CommercialServicesApiFp(this.configuration)
            .crmV1DealsheetCommercialServicesIdDuplicatePost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing dealsheet commercial service with the provided data
     * @summary update a dealsheet commercial service
     * @param {CommercialServicesApiCrmV1DealsheetCommercialServicesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetCommercialServicesIdPut(requestParameters, options) {
        return CommercialServicesApiFp(this.configuration)
            .crmV1DealsheetCommercialServicesIdPut(requestParameters.id, requestParameters.commercialService, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new dealsheet commercial service
     * @summary create dealsheet commercial service
     * @param {CommercialServicesApiCrmV1DealsheetCommercialServicesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetCommercialServicesPost(requestParameters, options) {
        return CommercialServicesApiFp(this.configuration)
            .crmV1DealsheetCommercialServicesPost(requestParameters.commercialService, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1DealsheetCommercialServicesGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * DealsheetsApi - axios parameter creator
 */
export const DealsheetsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all dealsheets with optional filtering and sorting
         * @summary List all dealsheets
         * @param {string} [dealsheetId] Filter by dealsheet ID
         * @param {string} [dealsheetOrgId] Filter by org ID
         * @param {string} [dealsheetStatus] Filter by status
         * @param {string} [dealsheetCustomerId] Filter by customer ID
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1DealsheetsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetsGet: async (dealsheetId, dealsheetOrgId, dealsheetStatus, dealsheetCustomerId, sortBy, sortDir, options = {}) => {
            const localVarPath = `/crm/v1/dealsheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (dealsheetId !== undefined) {
                localVarQueryParameter['dealsheetId'] = dealsheetId;
            }
            if (dealsheetOrgId !== undefined) {
                localVarQueryParameter['dealsheetOrgId'] = dealsheetOrgId;
            }
            if (dealsheetStatus !== undefined) {
                localVarQueryParameter['dealsheetStatus'] = dealsheetStatus;
            }
            if (dealsheetCustomerId !== undefined) {
                localVarQueryParameter['dealsheetCustomerId'] = dealsheetCustomerId;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an existing dealsheet by its ID
         * @summary delete a dealsheet
         * @param {string} id Dealsheet ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetsIdDelete', 'id', id);
            const localVarPath = `/crm/v1/dealsheets/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single dealsheet by its ID
         * @summary Get a dealsheet by ID
         * @param {string} id Dealsheet ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetsIdGet', 'id', id);
            const localVarPath = `/crm/v1/dealsheets/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing dealsheet with the provided data
         * @summary update a dealsheet
         * @param {string} id Dealsheet ID
         * @param {CrmServiceDomainModelDealsheet} dealsheet Dealsheet object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetsIdPut: async (id, dealsheet, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetsIdPut', 'id', id);
            // verify required parameter 'dealsheet' is not null or undefined
            assertParamExists('crmV1DealsheetsIdPut', 'dealsheet', dealsheet);
            const localVarPath = `/crm/v1/dealsheets/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(dealsheet, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new dealsheet with the provided data
         * @summary create a new dealsheet
         * @param {CrmServiceDomainModelDealsheet} dealsheet Dealsheet object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetsPost: async (dealsheet, options = {}) => {
            // verify required parameter 'dealsheet' is not null or undefined
            assertParamExists('crmV1DealsheetsPost', 'dealsheet', dealsheet);
            const localVarPath = `/crm/v1/dealsheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(dealsheet, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DealsheetsApi - functional programming interface
 */
export const DealsheetsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DealsheetsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all dealsheets with optional filtering and sorting
         * @summary List all dealsheets
         * @param {string} [dealsheetId] Filter by dealsheet ID
         * @param {string} [dealsheetOrgId] Filter by org ID
         * @param {string} [dealsheetStatus] Filter by status
         * @param {string} [dealsheetCustomerId] Filter by customer ID
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1DealsheetsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetsGet(dealsheetId, dealsheetOrgId, dealsheetStatus, dealsheetCustomerId, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetsGet(dealsheetId, dealsheetOrgId, dealsheetStatus, dealsheetCustomerId, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DealsheetsApi.crmV1DealsheetsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete an existing dealsheet by its ID
         * @summary delete a dealsheet
         * @param {string} id Dealsheet ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DealsheetsApi.crmV1DealsheetsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single dealsheet by its ID
         * @summary Get a dealsheet by ID
         * @param {string} id Dealsheet ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DealsheetsApi.crmV1DealsheetsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing dealsheet with the provided data
         * @summary update a dealsheet
         * @param {string} id Dealsheet ID
         * @param {CrmServiceDomainModelDealsheet} dealsheet Dealsheet object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetsIdPut(id, dealsheet, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetsIdPut(id, dealsheet, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DealsheetsApi.crmV1DealsheetsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new dealsheet with the provided data
         * @summary create a new dealsheet
         * @param {CrmServiceDomainModelDealsheet} dealsheet Dealsheet object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetsPost(dealsheet, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetsPost(dealsheet, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DealsheetsApi.crmV1DealsheetsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DealsheetsApi - factory interface
 */
export const DealsheetsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DealsheetsApiFp(configuration);
    return {
        /**
         * Get all dealsheets with optional filtering and sorting
         * @summary List all dealsheets
         * @param {DealsheetsApiCrmV1DealsheetsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetsGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1DealsheetsGet(requestParameters.dealsheetId, requestParameters.dealsheetOrgId, requestParameters.dealsheetStatus, requestParameters.dealsheetCustomerId, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * delete an existing dealsheet by its ID
         * @summary delete a dealsheet
         * @param {DealsheetsApiCrmV1DealsheetsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetsIdDelete(requestParameters, options) {
            return localVarFp.crmV1DealsheetsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single dealsheet by its ID
         * @summary Get a dealsheet by ID
         * @param {DealsheetsApiCrmV1DealsheetsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetsIdGet(requestParameters, options) {
            return localVarFp.crmV1DealsheetsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing dealsheet with the provided data
         * @summary update a dealsheet
         * @param {DealsheetsApiCrmV1DealsheetsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetsIdPut(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetsIdPut(requestParameters.id, requestParameters.dealsheet, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new dealsheet with the provided data
         * @summary create a new dealsheet
         * @param {DealsheetsApiCrmV1DealsheetsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetsPost(requestParameters, options) {
            return localVarFp.crmV1DealsheetsPost(requestParameters.dealsheet, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DealsheetsApi - object-oriented interface
 */
export class DealsheetsApi extends BaseAPI {
    /**
     * Get all dealsheets with optional filtering and sorting
     * @summary List all dealsheets
     * @param {DealsheetsApiCrmV1DealsheetsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetsGet(requestParameters = {}, options) {
        return DealsheetsApiFp(this.configuration)
            .crmV1DealsheetsGet(requestParameters.dealsheetId, requestParameters.dealsheetOrgId, requestParameters.dealsheetStatus, requestParameters.dealsheetCustomerId, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete an existing dealsheet by its ID
     * @summary delete a dealsheet
     * @param {DealsheetsApiCrmV1DealsheetsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetsIdDelete(requestParameters, options) {
        return DealsheetsApiFp(this.configuration)
            .crmV1DealsheetsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single dealsheet by its ID
     * @summary Get a dealsheet by ID
     * @param {DealsheetsApiCrmV1DealsheetsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetsIdGet(requestParameters, options) {
        return DealsheetsApiFp(this.configuration)
            .crmV1DealsheetsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing dealsheet with the provided data
     * @summary update a dealsheet
     * @param {DealsheetsApiCrmV1DealsheetsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetsIdPut(requestParameters, options) {
        return DealsheetsApiFp(this.configuration)
            .crmV1DealsheetsIdPut(requestParameters.id, requestParameters.dealsheet, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new dealsheet with the provided data
     * @summary create a new dealsheet
     * @param {DealsheetsApiCrmV1DealsheetsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetsPost(requestParameters, options) {
        return DealsheetsApiFp(this.configuration)
            .crmV1DealsheetsPost(requestParameters.dealsheet, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1DealsheetsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * DocRefsApi - axios parameter creator
 */
export const DocRefsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all doc refs with options to filter, sort, and paginate the results
         * @summary List all doc refs
         * @param {string} [id] Filter by doc ref ID
         * @param {string} [docsDocID] Filter by documents doc ID
         * @param {string} [refID] Filter by ref ID
         * @param {string} [refType] Filter by ref type
         * @param {string} [orgID] Filter by organization ID
         * @param {string} [sortBy] Sort by field (id, docsDocID, refID, createdAt, lastUpdatedAt)
         * @param {CrmV1DocRefsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocRefsGet: async (id, docsDocID, refID, refType, orgID, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/crm/v1/doc-refs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (docsDocID !== undefined) {
                localVarQueryParameter['docsDocID'] = docsDocID;
            }
            if (refID !== undefined) {
                localVarQueryParameter['refID'] = refID;
            }
            if (refType !== undefined) {
                localVarQueryParameter['refType'] = refType;
            }
            if (orgID !== undefined) {
                localVarQueryParameter['orgID'] = orgID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a doc ref from the system using its unique identifier
         * @summary Delete a doc ref
         * @param {string} id Doc Ref ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocRefsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DocRefsIdDelete', 'id', id);
            const localVarPath = `/crm/v1/doc-refs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single doc ref using its unique identifier
         * @summary Get a doc ref by ID
         * @param {string} id Doc Ref ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocRefsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DocRefsIdGet', 'id', id);
            const localVarPath = `/crm/v1/doc-refs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing doc ref with the provided details
         * @summary Update a doc ref
         * @param {string} id Doc Ref ID
         * @param {CrmServiceDomainModelDocRefs} docRef Doc Ref object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocRefsIdPut: async (id, docRef, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DocRefsIdPut', 'id', id);
            // verify required parameter 'docRef' is not null or undefined
            assertParamExists('crmV1DocRefsIdPut', 'docRef', docRef);
            const localVarPath = `/crm/v1/doc-refs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(docRef, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new doc ref with the provided details
         * @summary Create a new doc ref
         * @param {CrmServiceDomainModelDocRefs} docRef Doc Ref object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocRefsPost: async (docRef, options = {}) => {
            // verify required parameter 'docRef' is not null or undefined
            assertParamExists('crmV1DocRefsPost', 'docRef', docRef);
            const localVarPath = `/crm/v1/doc-refs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(docRef, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocRefsApi - functional programming interface
 */
export const DocRefsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocRefsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all doc refs with options to filter, sort, and paginate the results
         * @summary List all doc refs
         * @param {string} [id] Filter by doc ref ID
         * @param {string} [docsDocID] Filter by documents doc ID
         * @param {string} [refID] Filter by ref ID
         * @param {string} [refType] Filter by ref type
         * @param {string} [orgID] Filter by organization ID
         * @param {string} [sortBy] Sort by field (id, docsDocID, refID, createdAt, lastUpdatedAt)
         * @param {CrmV1DocRefsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DocRefsGet(id, docsDocID, refID, refType, orgID, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DocRefsGet(id, docsDocID, refID, refType, orgID, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.crmV1DocRefsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a doc ref from the system using its unique identifier
         * @summary Delete a doc ref
         * @param {string} id Doc Ref ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DocRefsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DocRefsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.crmV1DocRefsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single doc ref using its unique identifier
         * @summary Get a doc ref by ID
         * @param {string} id Doc Ref ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DocRefsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DocRefsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.crmV1DocRefsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing doc ref with the provided details
         * @summary Update a doc ref
         * @param {string} id Doc Ref ID
         * @param {CrmServiceDomainModelDocRefs} docRef Doc Ref object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DocRefsIdPut(id, docRef, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DocRefsIdPut(id, docRef, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.crmV1DocRefsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new doc ref with the provided details
         * @summary Create a new doc ref
         * @param {CrmServiceDomainModelDocRefs} docRef Doc Ref object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DocRefsPost(docRef, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DocRefsPost(docRef, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.crmV1DocRefsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DocRefsApi - factory interface
 */
export const DocRefsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocRefsApiFp(configuration);
    return {
        /**
         * Retrieve a list of all doc refs with options to filter, sort, and paginate the results
         * @summary List all doc refs
         * @param {DocRefsApiCrmV1DocRefsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocRefsGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1DocRefsGet(requestParameters.id, requestParameters.docsDocID, requestParameters.refID, requestParameters.refType, requestParameters.orgID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove a doc ref from the system using its unique identifier
         * @summary Delete a doc ref
         * @param {DocRefsApiCrmV1DocRefsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocRefsIdDelete(requestParameters, options) {
            return localVarFp.crmV1DocRefsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single doc ref using its unique identifier
         * @summary Get a doc ref by ID
         * @param {DocRefsApiCrmV1DocRefsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocRefsIdGet(requestParameters, options) {
            return localVarFp.crmV1DocRefsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing doc ref with the provided details
         * @summary Update a doc ref
         * @param {DocRefsApiCrmV1DocRefsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocRefsIdPut(requestParameters, options) {
            return localVarFp
                .crmV1DocRefsIdPut(requestParameters.id, requestParameters.docRef, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new doc ref with the provided details
         * @summary Create a new doc ref
         * @param {DocRefsApiCrmV1DocRefsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocRefsPost(requestParameters, options) {
            return localVarFp.crmV1DocRefsPost(requestParameters.docRef, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocRefsApi - object-oriented interface
 */
export class DocRefsApi extends BaseAPI {
    /**
     * Retrieve a list of all doc refs with options to filter, sort, and paginate the results
     * @summary List all doc refs
     * @param {DocRefsApiCrmV1DocRefsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DocRefsGet(requestParameters = {}, options) {
        return DocRefsApiFp(this.configuration)
            .crmV1DocRefsGet(requestParameters.id, requestParameters.docsDocID, requestParameters.refID, requestParameters.refType, requestParameters.orgID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a doc ref from the system using its unique identifier
     * @summary Delete a doc ref
     * @param {DocRefsApiCrmV1DocRefsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DocRefsIdDelete(requestParameters, options) {
        return DocRefsApiFp(this.configuration)
            .crmV1DocRefsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single doc ref using its unique identifier
     * @summary Get a doc ref by ID
     * @param {DocRefsApiCrmV1DocRefsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DocRefsIdGet(requestParameters, options) {
        return DocRefsApiFp(this.configuration)
            .crmV1DocRefsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing doc ref with the provided details
     * @summary Update a doc ref
     * @param {DocRefsApiCrmV1DocRefsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DocRefsIdPut(requestParameters, options) {
        return DocRefsApiFp(this.configuration)
            .crmV1DocRefsIdPut(requestParameters.id, requestParameters.docRef, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new doc ref with the provided details
     * @summary Create a new doc ref
     * @param {DocRefsApiCrmV1DocRefsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DocRefsPost(requestParameters, options) {
        return DocRefsApiFp(this.configuration)
            .crmV1DocRefsPost(requestParameters.docRef, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1DocRefsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * DocsApi - axios parameter creator
 */
export const DocsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a list of documents that have doc refs with a specific RefID, with optional filtering and pagination
         * @summary List documents by RefID
         * @param {string} refID Ref ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocsByRefIdRefIDGet: async (refID, limit, offset, sortBy, sortDir, options = {}) => {
            // verify required parameter 'refID' is not null or undefined
            assertParamExists('crmV1DocsByRefIdRefIDGet', 'refID', refID);
            const localVarPath = `/crm/v1/docs/by-ref-id/{refID}`.replace('{refID}', encodeURIComponent(String(refID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of documents with optional filtering and pagination
         * @summary List documents
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocsGet: async (limit, offset, sortBy, sortDir, options = {}) => {
            const localVarPath = `/crm/v1/docs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a doc from the system using its unique identifier
         * @summary Delete a doc
         * @param {string} id Doc ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DocsIdDelete', 'id', id);
            const localVarPath = `/crm/v1/docs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single doc using its unique identifier
         * @summary Get a doc by ID
         * @param {string} id Doc ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DocsIdGet', 'id', id);
            const localVarPath = `/crm/v1/docs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing doc with the provided details
         * @summary Update a doc
         * @param {string} id Doc ID
         * @param {ModelDocument} doc Doc object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocsIdPut: async (id, doc, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DocsIdPut', 'id', id);
            // verify required parameter 'doc' is not null or undefined
            assertParamExists('crmV1DocsIdPut', 'doc', doc);
            const localVarPath = `/crm/v1/docs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(doc, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new doc with the provided details
         * @summary Create a new doc
         * @param {ModelDocument} doc Doc object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocsPost: async (doc, options = {}) => {
            // verify required parameter 'doc' is not null or undefined
            assertParamExists('crmV1DocsPost', 'doc', doc);
            const localVarPath = `/crm/v1/docs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(doc, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocsApi - functional programming interface
 */
export const DocsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a list of documents that have doc refs with a specific RefID, with optional filtering and pagination
         * @summary List documents by RefID
         * @param {string} refID Ref ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DocsByRefIdRefIDGet(refID, limit, offset, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DocsByRefIdRefIDGet(refID, limit, offset, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.crmV1DocsByRefIdRefIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of documents with optional filtering and pagination
         * @summary List documents
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DocsGet(limit, offset, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DocsGet(limit, offset, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.crmV1DocsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a doc from the system using its unique identifier
         * @summary Delete a doc
         * @param {string} id Doc ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DocsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DocsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.crmV1DocsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single doc using its unique identifier
         * @summary Get a doc by ID
         * @param {string} id Doc ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DocsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DocsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.crmV1DocsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing doc with the provided details
         * @summary Update a doc
         * @param {string} id Doc ID
         * @param {ModelDocument} doc Doc object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DocsIdPut(id, doc, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DocsIdPut(id, doc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.crmV1DocsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new doc with the provided details
         * @summary Create a new doc
         * @param {ModelDocument} doc Doc object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DocsPost(doc, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DocsPost(doc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.crmV1DocsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DocsApi - factory interface
 */
export const DocsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocsApiFp(configuration);
    return {
        /**
         * Get a list of documents that have doc refs with a specific RefID, with optional filtering and pagination
         * @summary List documents by RefID
         * @param {DocsApiCrmV1DocsByRefIdRefIDGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocsByRefIdRefIDGet(requestParameters, options) {
            return localVarFp
                .crmV1DocsByRefIdRefIDGet(requestParameters.refID, requestParameters.limit, requestParameters.offset, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a list of documents with optional filtering and pagination
         * @summary List documents
         * @param {DocsApiCrmV1DocsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocsGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1DocsGet(requestParameters.limit, requestParameters.offset, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove a doc from the system using its unique identifier
         * @summary Delete a doc
         * @param {DocsApiCrmV1DocsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocsIdDelete(requestParameters, options) {
            return localVarFp.crmV1DocsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single doc using its unique identifier
         * @summary Get a doc by ID
         * @param {DocsApiCrmV1DocsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocsIdGet(requestParameters, options) {
            return localVarFp.crmV1DocsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing doc with the provided details
         * @summary Update a doc
         * @param {DocsApiCrmV1DocsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocsIdPut(requestParameters, options) {
            return localVarFp
                .crmV1DocsIdPut(requestParameters.id, requestParameters.doc, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new doc with the provided details
         * @summary Create a new doc
         * @param {DocsApiCrmV1DocsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DocsPost(requestParameters, options) {
            return localVarFp.crmV1DocsPost(requestParameters.doc, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocsApi - object-oriented interface
 */
export class DocsApi extends BaseAPI {
    /**
     * Get a list of documents that have doc refs with a specific RefID, with optional filtering and pagination
     * @summary List documents by RefID
     * @param {DocsApiCrmV1DocsByRefIdRefIDGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DocsByRefIdRefIDGet(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .crmV1DocsByRefIdRefIDGet(requestParameters.refID, requestParameters.limit, requestParameters.offset, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a list of documents with optional filtering and pagination
     * @summary List documents
     * @param {DocsApiCrmV1DocsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DocsGet(requestParameters = {}, options) {
        return DocsApiFp(this.configuration)
            .crmV1DocsGet(requestParameters.limit, requestParameters.offset, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a doc from the system using its unique identifier
     * @summary Delete a doc
     * @param {DocsApiCrmV1DocsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DocsIdDelete(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .crmV1DocsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single doc using its unique identifier
     * @summary Get a doc by ID
     * @param {DocsApiCrmV1DocsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DocsIdGet(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .crmV1DocsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing doc with the provided details
     * @summary Update a doc
     * @param {DocsApiCrmV1DocsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DocsIdPut(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .crmV1DocsIdPut(requestParameters.id, requestParameters.doc, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new doc with the provided details
     * @summary Create a new doc
     * @param {DocsApiCrmV1DocsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DocsPost(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .crmV1DocsPost(requestParameters.doc, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EquipmentServicesApi - axios parameter creator
 */
export const EquipmentServicesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all dealsheet equipment services with optional filtering and sorting
         * @summary List all dealsheet equipment services
         * @param {string} [id] Filter by dealsheet equipment service ID
         * @param {string} [siteID] Filter by site ID (returns only services NOT associated with RFPs)
         * @param {string} [siteIDWithRFP] Filter by site ID (returns only services associated with RFPs)
         * @param {string} [rfpSiteID] Filter by RFP site ID
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1DealsheetEquipmentServicesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetEquipmentServicesGet: async (id, siteID, siteIDWithRFP, rfpSiteID, dealsheetID, sortBy, sortDir, limit, offset, options = {}) => {
            const localVarPath = `/crm/v1/dealsheet-equipment-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (siteID !== undefined) {
                localVarQueryParameter['siteID'] = siteID;
            }
            if (siteIDWithRFP !== undefined) {
                localVarQueryParameter['siteIDWithRFP'] = siteIDWithRFP;
            }
            if (rfpSiteID !== undefined) {
                localVarQueryParameter['rfpSiteID'] = rfpSiteID;
            }
            if (dealsheetID !== undefined) {
                localVarQueryParameter['dealsheetID'] = dealsheetID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a dealsheet equipment service by its ID
         * @summary Delete a dealsheet equipment service
         * @param {string} id Dealsheet Equipment Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetEquipmentServicesIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetEquipmentServicesIdDelete', 'id', id);
            const localVarPath = `/crm/v1/dealsheet-equipment-services/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a copy of an existing equipment service including all order items with their values. The duplicated service will be on the same site as the source.
         * @summary Duplicate an equipment service with all order items
         * @param {string} id Source Equipment Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetEquipmentServicesIdDuplicatePost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetEquipmentServicesIdDuplicatePost', 'id', id);
            const localVarPath = `/crm/v1/dealsheet-equipment-services/{id}/duplicate`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single dealsheet equipment service by its ID
         * @summary Get a dealsheet equipment service
         * @param {string} id Dealsheet Equipment Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetEquipmentServicesIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetEquipmentServicesIdGet', 'id', id);
            const localVarPath = `/crm/v1/dealsheet-equipment-services/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing dealsheet equipment service with the provided data
         * @summary Update a dealsheet equipment service
         * @param {string} id Dealsheet Equipment Service ID
         * @param {ModelEquipmentService} equipmentService Dealsheet Equipment Service object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetEquipmentServicesIdPut: async (id, equipmentService, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetEquipmentServicesIdPut', 'id', id);
            // verify required parameter 'equipmentService' is not null or undefined
            assertParamExists('crmV1DealsheetEquipmentServicesIdPut', 'equipmentService', equipmentService);
            const localVarPath = `/crm/v1/dealsheet-equipment-services/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentService, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new dealsheet equipment service
         * @summary Create a dealsheet equipment service
         * @param {ModelEquipmentService} equipmentService Dealsheet Equipment Service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetEquipmentServicesPost: async (equipmentService, options = {}) => {
            // verify required parameter 'equipmentService' is not null or undefined
            assertParamExists('crmV1DealsheetEquipmentServicesPost', 'equipmentService', equipmentService);
            const localVarPath = `/crm/v1/dealsheet-equipment-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentService, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EquipmentServicesApi - functional programming interface
 */
export const EquipmentServicesApiFp = function (configuration) {
    const localVarAxiosParamCreator = EquipmentServicesApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all dealsheet equipment services with optional filtering and sorting
         * @summary List all dealsheet equipment services
         * @param {string} [id] Filter by dealsheet equipment service ID
         * @param {string} [siteID] Filter by site ID (returns only services NOT associated with RFPs)
         * @param {string} [siteIDWithRFP] Filter by site ID (returns only services associated with RFPs)
         * @param {string} [rfpSiteID] Filter by RFP site ID
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1DealsheetEquipmentServicesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetEquipmentServicesGet(id, siteID, siteIDWithRFP, rfpSiteID, dealsheetID, sortBy, sortDir, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetEquipmentServicesGet(id, siteID, siteIDWithRFP, rfpSiteID, dealsheetID, sortBy, sortDir, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentServicesApi.crmV1DealsheetEquipmentServicesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a dealsheet equipment service by its ID
         * @summary Delete a dealsheet equipment service
         * @param {string} id Dealsheet Equipment Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetEquipmentServicesIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetEquipmentServicesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentServicesApi.crmV1DealsheetEquipmentServicesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a copy of an existing equipment service including all order items with their values. The duplicated service will be on the same site as the source.
         * @summary Duplicate an equipment service with all order items
         * @param {string} id Source Equipment Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetEquipmentServicesIdDuplicatePost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetEquipmentServicesIdDuplicatePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentServicesApi.crmV1DealsheetEquipmentServicesIdDuplicatePost']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single dealsheet equipment service by its ID
         * @summary Get a dealsheet equipment service
         * @param {string} id Dealsheet Equipment Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetEquipmentServicesIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetEquipmentServicesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentServicesApi.crmV1DealsheetEquipmentServicesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing dealsheet equipment service with the provided data
         * @summary Update a dealsheet equipment service
         * @param {string} id Dealsheet Equipment Service ID
         * @param {ModelEquipmentService} equipmentService Dealsheet Equipment Service object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetEquipmentServicesIdPut(id, equipmentService, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetEquipmentServicesIdPut(id, equipmentService, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentServicesApi.crmV1DealsheetEquipmentServicesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new dealsheet equipment service
         * @summary Create a dealsheet equipment service
         * @param {ModelEquipmentService} equipmentService Dealsheet Equipment Service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetEquipmentServicesPost(equipmentService, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetEquipmentServicesPost(equipmentService, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentServicesApi.crmV1DealsheetEquipmentServicesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EquipmentServicesApi - factory interface
 */
export const EquipmentServicesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EquipmentServicesApiFp(configuration);
    return {
        /**
         * Get all dealsheet equipment services with optional filtering and sorting
         * @summary List all dealsheet equipment services
         * @param {EquipmentServicesApiCrmV1DealsheetEquipmentServicesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetEquipmentServicesGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1DealsheetEquipmentServicesGet(requestParameters.id, requestParameters.siteID, requestParameters.siteIDWithRFP, requestParameters.rfpSiteID, requestParameters.dealsheetID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.limit, requestParameters.offset, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete a dealsheet equipment service by its ID
         * @summary Delete a dealsheet equipment service
         * @param {EquipmentServicesApiCrmV1DealsheetEquipmentServicesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetEquipmentServicesIdDelete(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetEquipmentServicesIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Creates a copy of an existing equipment service including all order items with their values. The duplicated service will be on the same site as the source.
         * @summary Duplicate an equipment service with all order items
         * @param {EquipmentServicesApiCrmV1DealsheetEquipmentServicesIdDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetEquipmentServicesIdDuplicatePost(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetEquipmentServicesIdDuplicatePost(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a single dealsheet equipment service by its ID
         * @summary Get a dealsheet equipment service
         * @param {EquipmentServicesApiCrmV1DealsheetEquipmentServicesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetEquipmentServicesIdGet(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetEquipmentServicesIdGet(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update an existing dealsheet equipment service with the provided data
         * @summary Update a dealsheet equipment service
         * @param {EquipmentServicesApiCrmV1DealsheetEquipmentServicesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetEquipmentServicesIdPut(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetEquipmentServicesIdPut(requestParameters.id, requestParameters.equipmentService, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new dealsheet equipment service
         * @summary Create a dealsheet equipment service
         * @param {EquipmentServicesApiCrmV1DealsheetEquipmentServicesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetEquipmentServicesPost(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetEquipmentServicesPost(requestParameters.equipmentService, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * EquipmentServicesApi - object-oriented interface
 */
export class EquipmentServicesApi extends BaseAPI {
    /**
     * Get all dealsheet equipment services with optional filtering and sorting
     * @summary List all dealsheet equipment services
     * @param {EquipmentServicesApiCrmV1DealsheetEquipmentServicesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetEquipmentServicesGet(requestParameters = {}, options) {
        return EquipmentServicesApiFp(this.configuration)
            .crmV1DealsheetEquipmentServicesGet(requestParameters.id, requestParameters.siteID, requestParameters.siteIDWithRFP, requestParameters.rfpSiteID, requestParameters.dealsheetID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.limit, requestParameters.offset, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a dealsheet equipment service by its ID
     * @summary Delete a dealsheet equipment service
     * @param {EquipmentServicesApiCrmV1DealsheetEquipmentServicesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetEquipmentServicesIdDelete(requestParameters, options) {
        return EquipmentServicesApiFp(this.configuration)
            .crmV1DealsheetEquipmentServicesIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a copy of an existing equipment service including all order items with their values. The duplicated service will be on the same site as the source.
     * @summary Duplicate an equipment service with all order items
     * @param {EquipmentServicesApiCrmV1DealsheetEquipmentServicesIdDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetEquipmentServicesIdDuplicatePost(requestParameters, options) {
        return EquipmentServicesApiFp(this.configuration)
            .crmV1DealsheetEquipmentServicesIdDuplicatePost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single dealsheet equipment service by its ID
     * @summary Get a dealsheet equipment service
     * @param {EquipmentServicesApiCrmV1DealsheetEquipmentServicesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetEquipmentServicesIdGet(requestParameters, options) {
        return EquipmentServicesApiFp(this.configuration)
            .crmV1DealsheetEquipmentServicesIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing dealsheet equipment service with the provided data
     * @summary Update a dealsheet equipment service
     * @param {EquipmentServicesApiCrmV1DealsheetEquipmentServicesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetEquipmentServicesIdPut(requestParameters, options) {
        return EquipmentServicesApiFp(this.configuration)
            .crmV1DealsheetEquipmentServicesIdPut(requestParameters.id, requestParameters.equipmentService, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new dealsheet equipment service
     * @summary Create a dealsheet equipment service
     * @param {EquipmentServicesApiCrmV1DealsheetEquipmentServicesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetEquipmentServicesPost(requestParameters, options) {
        return EquipmentServicesApiFp(this.configuration)
            .crmV1DealsheetEquipmentServicesPost(requestParameters.equipmentService, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1DealsheetEquipmentServicesGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * InvoiceGraderApi - axios parameter creator
 */
export const InvoiceGraderApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Internal. Submissions newest first, for staff review.
         * @summary List invoice grader submissions
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1InvoiceGraderSubmissionsGet: async (limit, offset, options = {}) => {
            const localVarPath = `/crm/v1/invoice-grader/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Internal. Returns the submission whether or not it is unlocked — an abandoned submission is exactly the case staff need to look at.
         * @summary Get one invoice grader submission
         * @param {string} id Submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1InvoiceGraderSubmissionsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1InvoiceGraderSubmissionsIdGet', 'id', id);
            const localVarPath = `/crm/v1/invoice-grader/submissions/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public. Returns the results once the visitor has completed lead capture, and 403 before that. Supports reloading the page and polling.
         * @summary Read a submission\'s results
         * @param {string} id Submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1PublicInvoiceGraderSubmissionsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1PublicInvoiceGraderSubmissionsIdGet', 'id', id);
            const localVarPath = `/crm/v1/public/invoice-grader/submissions/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public. Records the visitor\'s contact details, creates the lead, and returns the scored submission. Lead creation is non-fatal: the results are returned either way.
         * @summary Capture the lead and release the results
         * @param {string} id Submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1PublicInvoiceGraderSubmissionsIdLeadPost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1PublicInvoiceGraderSubmissionsIdLeadPost', 'id', id);
            const localVarPath = `/crm/v1/public/invoice-grader/submissions/{id}/lead`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public. Accepts one or more invoices and returns the submission id. The results are deliberately not included in this response: they are released by the lead endpoint.
         * @summary Submit invoices to the grader
         * @param {File} files Invoice files (PDF or image), at most 10, 10MB each
         * @param {string} [businessCategory] Broad business type
         * @param {string} [locationCount] Number of locations, as a bucket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1PublicInvoiceGraderSubmissionsPost: async (files, businessCategory, locationCount, options = {}) => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('crmV1PublicInvoiceGraderSubmissionsPost', 'files', files);
            const localVarPath = `/crm/v1/public/invoice-grader/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (files !== undefined) {
                localVarFormParams.append('files', files);
            }
            if (businessCategory !== undefined) {
                localVarFormParams.append('businessCategory', businessCategory);
            }
            if (locationCount !== undefined) {
                localVarFormParams.append('locationCount', locationCount);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * InvoiceGraderApi - functional programming interface
 */
export const InvoiceGraderApiFp = function (configuration) {
    const localVarAxiosParamCreator = InvoiceGraderApiAxiosParamCreator(configuration);
    return {
        /**
         * Internal. Submissions newest first, for staff review.
         * @summary List invoice grader submissions
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1InvoiceGraderSubmissionsGet(limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1InvoiceGraderSubmissionsGet(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceGraderApi.crmV1InvoiceGraderSubmissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Internal. Returns the submission whether or not it is unlocked — an abandoned submission is exactly the case staff need to look at.
         * @summary Get one invoice grader submission
         * @param {string} id Submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1InvoiceGraderSubmissionsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1InvoiceGraderSubmissionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceGraderApi.crmV1InvoiceGraderSubmissionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public. Returns the results once the visitor has completed lead capture, and 403 before that. Supports reloading the page and polling.
         * @summary Read a submission\'s results
         * @param {string} id Submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1PublicInvoiceGraderSubmissionsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1PublicInvoiceGraderSubmissionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceGraderApi.crmV1PublicInvoiceGraderSubmissionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public. Records the visitor\'s contact details, creates the lead, and returns the scored submission. Lead creation is non-fatal: the results are returned either way.
         * @summary Capture the lead and release the results
         * @param {string} id Submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1PublicInvoiceGraderSubmissionsIdLeadPost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1PublicInvoiceGraderSubmissionsIdLeadPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceGraderApi.crmV1PublicInvoiceGraderSubmissionsIdLeadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public. Accepts one or more invoices and returns the submission id. The results are deliberately not included in this response: they are released by the lead endpoint.
         * @summary Submit invoices to the grader
         * @param {File} files Invoice files (PDF or image), at most 10, 10MB each
         * @param {string} [businessCategory] Broad business type
         * @param {string} [locationCount] Number of locations, as a bucket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1PublicInvoiceGraderSubmissionsPost(files, businessCategory, locationCount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1PublicInvoiceGraderSubmissionsPost(files, businessCategory, locationCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceGraderApi.crmV1PublicInvoiceGraderSubmissionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * InvoiceGraderApi - factory interface
 */
export const InvoiceGraderApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InvoiceGraderApiFp(configuration);
    return {
        /**
         * Internal. Submissions newest first, for staff review.
         * @summary List invoice grader submissions
         * @param {InvoiceGraderApiCrmV1InvoiceGraderSubmissionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1InvoiceGraderSubmissionsGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1InvoiceGraderSubmissionsGet(requestParameters.limit, requestParameters.offset, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Internal. Returns the submission whether or not it is unlocked — an abandoned submission is exactly the case staff need to look at.
         * @summary Get one invoice grader submission
         * @param {InvoiceGraderApiCrmV1InvoiceGraderSubmissionsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1InvoiceGraderSubmissionsIdGet(requestParameters, options) {
            return localVarFp.crmV1InvoiceGraderSubmissionsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Public. Returns the results once the visitor has completed lead capture, and 403 before that. Supports reloading the page and polling.
         * @summary Read a submission\'s results
         * @param {InvoiceGraderApiCrmV1PublicInvoiceGraderSubmissionsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1PublicInvoiceGraderSubmissionsIdGet(requestParameters, options) {
            return localVarFp
                .crmV1PublicInvoiceGraderSubmissionsIdGet(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Public. Records the visitor\'s contact details, creates the lead, and returns the scored submission. Lead creation is non-fatal: the results are returned either way.
         * @summary Capture the lead and release the results
         * @param {InvoiceGraderApiCrmV1PublicInvoiceGraderSubmissionsIdLeadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1PublicInvoiceGraderSubmissionsIdLeadPost(requestParameters, options) {
            return localVarFp
                .crmV1PublicInvoiceGraderSubmissionsIdLeadPost(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Public. Accepts one or more invoices and returns the submission id. The results are deliberately not included in this response: they are released by the lead endpoint.
         * @summary Submit invoices to the grader
         * @param {InvoiceGraderApiCrmV1PublicInvoiceGraderSubmissionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1PublicInvoiceGraderSubmissionsPost(requestParameters, options) {
            return localVarFp
                .crmV1PublicInvoiceGraderSubmissionsPost(requestParameters.files, requestParameters.businessCategory, requestParameters.locationCount, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * InvoiceGraderApi - object-oriented interface
 */
export class InvoiceGraderApi extends BaseAPI {
    /**
     * Internal. Submissions newest first, for staff review.
     * @summary List invoice grader submissions
     * @param {InvoiceGraderApiCrmV1InvoiceGraderSubmissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1InvoiceGraderSubmissionsGet(requestParameters = {}, options) {
        return InvoiceGraderApiFp(this.configuration)
            .crmV1InvoiceGraderSubmissionsGet(requestParameters.limit, requestParameters.offset, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Internal. Returns the submission whether or not it is unlocked — an abandoned submission is exactly the case staff need to look at.
     * @summary Get one invoice grader submission
     * @param {InvoiceGraderApiCrmV1InvoiceGraderSubmissionsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1InvoiceGraderSubmissionsIdGet(requestParameters, options) {
        return InvoiceGraderApiFp(this.configuration)
            .crmV1InvoiceGraderSubmissionsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Public. Returns the results once the visitor has completed lead capture, and 403 before that. Supports reloading the page and polling.
     * @summary Read a submission\'s results
     * @param {InvoiceGraderApiCrmV1PublicInvoiceGraderSubmissionsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1PublicInvoiceGraderSubmissionsIdGet(requestParameters, options) {
        return InvoiceGraderApiFp(this.configuration)
            .crmV1PublicInvoiceGraderSubmissionsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Public. Records the visitor\'s contact details, creates the lead, and returns the scored submission. Lead creation is non-fatal: the results are returned either way.
     * @summary Capture the lead and release the results
     * @param {InvoiceGraderApiCrmV1PublicInvoiceGraderSubmissionsIdLeadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1PublicInvoiceGraderSubmissionsIdLeadPost(requestParameters, options) {
        return InvoiceGraderApiFp(this.configuration)
            .crmV1PublicInvoiceGraderSubmissionsIdLeadPost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Public. Accepts one or more invoices and returns the submission id. The results are deliberately not included in this response: they are released by the lead endpoint.
     * @summary Submit invoices to the grader
     * @param {InvoiceGraderApiCrmV1PublicInvoiceGraderSubmissionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1PublicInvoiceGraderSubmissionsPost(requestParameters, options) {
        return InvoiceGraderApiFp(this.configuration)
            .crmV1PublicInvoiceGraderSubmissionsPost(requestParameters.files, requestParameters.businessCategory, requestParameters.locationCount, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * IssuesApi - axios parameter creator
 */
export const IssuesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a list of issues with optional filtering, sorting, and pagination. Supports filtering by affectedIds (multiple values: ?affectedIds=d_1&affectedIds=d_2), enriched with refData
         * @summary List issues
         * @param {Array<string>} [affectedIds] Document IDs to search for
         * @param {string} [id] Filter by issue ID
         * @param {string} [refID] Filter by ref ID
         * @param {string} [refType] Filter by ref type
         * @param {string} [issueType] Filter by issue type
         * @param {string} [status] Filter by status
         * @param {string} [sortBy] Sort by field (createdAt, updatedAt)
         * @param {string} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1IssuesGet: async (affectedIds, id, refID, refType, issueType, status, sortBy, sortDir, limit, offset, options = {}) => {
            const localVarPath = `/crm/v1/issues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (affectedIds) {
                localVarQueryParameter['affectedIds'] = affectedIds;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (refID !== undefined) {
                localVarQueryParameter['refID'] = refID;
            }
            if (refType !== undefined) {
                localVarQueryParameter['refType'] = refType;
            }
            if (issueType !== undefined) {
                localVarQueryParameter['issueType'] = issueType;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * IssuesApi - functional programming interface
 */
export const IssuesApiFp = function (configuration) {
    const localVarAxiosParamCreator = IssuesApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a list of issues with optional filtering, sorting, and pagination. Supports filtering by affectedIds (multiple values: ?affectedIds=d_1&affectedIds=d_2), enriched with refData
         * @summary List issues
         * @param {Array<string>} [affectedIds] Document IDs to search for
         * @param {string} [id] Filter by issue ID
         * @param {string} [refID] Filter by ref ID
         * @param {string} [refType] Filter by ref type
         * @param {string} [issueType] Filter by issue type
         * @param {string} [status] Filter by status
         * @param {string} [sortBy] Sort by field (createdAt, updatedAt)
         * @param {string} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1IssuesGet(affectedIds, id, refID, refType, issueType, status, sortBy, sortDir, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1IssuesGet(affectedIds, id, refID, refType, issueType, status, sortBy, sortDir, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IssuesApi.crmV1IssuesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * IssuesApi - factory interface
 */
export const IssuesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = IssuesApiFp(configuration);
    return {
        /**
         * Get a list of issues with optional filtering, sorting, and pagination. Supports filtering by affectedIds (multiple values: ?affectedIds=d_1&affectedIds=d_2), enriched with refData
         * @summary List issues
         * @param {IssuesApiCrmV1IssuesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1IssuesGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1IssuesGet(requestParameters.affectedIds, requestParameters.id, requestParameters.refID, requestParameters.refType, requestParameters.issueType, requestParameters.status, requestParameters.sortBy, requestParameters.sortDir, requestParameters.limit, requestParameters.offset, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * IssuesApi - object-oriented interface
 */
export class IssuesApi extends BaseAPI {
    /**
     * Get a list of issues with optional filtering, sorting, and pagination. Supports filtering by affectedIds (multiple values: ?affectedIds=d_1&affectedIds=d_2), enriched with refData
     * @summary List issues
     * @param {IssuesApiCrmV1IssuesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1IssuesGet(requestParameters = {}, options) {
        return IssuesApiFp(this.configuration)
            .crmV1IssuesGet(requestParameters.affectedIds, requestParameters.id, requestParameters.refID, requestParameters.refType, requestParameters.issueType, requestParameters.status, requestParameters.sortBy, requestParameters.sortDir, requestParameters.limit, requestParameters.offset, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LocationsApi - axios parameter creator
 */
export const LocationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all locations
         * @param {string} [locationId] Filter by location ID
         * @param {string} [locationOrganizationId] Filter by organization ID
         * @param {string} [locationCity] Filter by city
         * @param {string} [locationState] Filter by state
         * @param {string} [locationPostcode] Filter by postcode
         * @param {string} [locationCountry] Filter by country
         * @param {string} [locationLabel] Filter by label
         * @param {string} [sortBy] Sort by field (locationId, locationOrganizationId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, locationSortOrder, locationCreatedAt, locationLastUpdatedAt)
         * @param {CrmV1LocationsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1LocationsGet: async (locationId, locationOrganizationId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, sortBy, sortDir, options = {}) => {
            const localVarPath = `/crm/v1/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }
            if (locationOrganizationId !== undefined) {
                localVarQueryParameter['locationOrganizationId'] = locationOrganizationId;
            }
            if (locationCity !== undefined) {
                localVarQueryParameter['locationCity'] = locationCity;
            }
            if (locationState !== undefined) {
                localVarQueryParameter['locationState'] = locationState;
            }
            if (locationPostcode !== undefined) {
                localVarQueryParameter['locationPostcode'] = locationPostcode;
            }
            if (locationCountry !== undefined) {
                localVarQueryParameter['locationCountry'] = locationCountry;
            }
            if (locationLabel !== undefined) {
                localVarQueryParameter['locationLabel'] = locationLabel;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an existing location by its ID
         * @summary delete a location
         * @param {string} id Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1LocationsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1LocationsIdDelete', 'id', id);
            const localVarPath = `/crm/v1/locations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single location by its ID
         * @summary Get a location by ID
         * @param {string} id Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1LocationsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1LocationsIdGet', 'id', id);
            const localVarPath = `/crm/v1/locations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing location with the provided data
         * @summary update a location
         * @param {string} id Location ID
         * @param {ModelLocation} location Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1LocationsIdPut: async (id, location, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1LocationsIdPut', 'id', id);
            // verify required parameter 'location' is not null or undefined
            assertParamExists('crmV1LocationsIdPut', 'location', location);
            const localVarPath = `/crm/v1/locations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(location, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new location with the provided data
         * @summary create a new location
         * @param {ModelLocation} location Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1LocationsPost: async (location, options = {}) => {
            // verify required parameter 'location' is not null or undefined
            assertParamExists('crmV1LocationsPost', 'location', location);
            const localVarPath = `/crm/v1/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(location, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LocationsApi - functional programming interface
 */
export const LocationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all locations
         * @param {string} [locationId] Filter by location ID
         * @param {string} [locationOrganizationId] Filter by organization ID
         * @param {string} [locationCity] Filter by city
         * @param {string} [locationState] Filter by state
         * @param {string} [locationPostcode] Filter by postcode
         * @param {string} [locationCountry] Filter by country
         * @param {string} [locationLabel] Filter by label
         * @param {string} [sortBy] Sort by field (locationId, locationOrganizationId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, locationSortOrder, locationCreatedAt, locationLastUpdatedAt)
         * @param {CrmV1LocationsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1LocationsGet(locationId, locationOrganizationId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1LocationsGet(locationId, locationOrganizationId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.crmV1LocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete an existing location by its ID
         * @summary delete a location
         * @param {string} id Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1LocationsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1LocationsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.crmV1LocationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single location by its ID
         * @summary Get a location by ID
         * @param {string} id Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1LocationsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1LocationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.crmV1LocationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing location with the provided data
         * @summary update a location
         * @param {string} id Location ID
         * @param {ModelLocation} location Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1LocationsIdPut(id, location, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1LocationsIdPut(id, location, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.crmV1LocationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new location with the provided data
         * @summary create a new location
         * @param {ModelLocation} location Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1LocationsPost(location, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1LocationsPost(location, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.crmV1LocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * LocationsApi - factory interface
 */
export const LocationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LocationsApiFp(configuration);
    return {
        /**
         * Get all locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all locations
         * @param {LocationsApiCrmV1LocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1LocationsGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1LocationsGet(requestParameters.locationId, requestParameters.locationOrganizationId, requestParameters.locationCity, requestParameters.locationState, requestParameters.locationPostcode, requestParameters.locationCountry, requestParameters.locationLabel, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * delete an existing location by its ID
         * @summary delete a location
         * @param {LocationsApiCrmV1LocationsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1LocationsIdDelete(requestParameters, options) {
            return localVarFp.crmV1LocationsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single location by its ID
         * @summary Get a location by ID
         * @param {LocationsApiCrmV1LocationsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1LocationsIdGet(requestParameters, options) {
            return localVarFp.crmV1LocationsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing location with the provided data
         * @summary update a location
         * @param {LocationsApiCrmV1LocationsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1LocationsIdPut(requestParameters, options) {
            return localVarFp
                .crmV1LocationsIdPut(requestParameters.id, requestParameters.location, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new location with the provided data
         * @summary create a new location
         * @param {LocationsApiCrmV1LocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1LocationsPost(requestParameters, options) {
            return localVarFp.crmV1LocationsPost(requestParameters.location, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LocationsApi - object-oriented interface
 */
export class LocationsApi extends BaseAPI {
    /**
     * Get all locations with optional filtering and sorting. Supports pagination and field filtering.
     * @summary List all locations
     * @param {LocationsApiCrmV1LocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1LocationsGet(requestParameters = {}, options) {
        return LocationsApiFp(this.configuration)
            .crmV1LocationsGet(requestParameters.locationId, requestParameters.locationOrganizationId, requestParameters.locationCity, requestParameters.locationState, requestParameters.locationPostcode, requestParameters.locationCountry, requestParameters.locationLabel, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete an existing location by its ID
     * @summary delete a location
     * @param {LocationsApiCrmV1LocationsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1LocationsIdDelete(requestParameters, options) {
        return LocationsApiFp(this.configuration)
            .crmV1LocationsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single location by its ID
     * @summary Get a location by ID
     * @param {LocationsApiCrmV1LocationsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1LocationsIdGet(requestParameters, options) {
        return LocationsApiFp(this.configuration)
            .crmV1LocationsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing location with the provided data
     * @summary update a location
     * @param {LocationsApiCrmV1LocationsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1LocationsIdPut(requestParameters, options) {
        return LocationsApiFp(this.configuration)
            .crmV1LocationsIdPut(requestParameters.id, requestParameters.location, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new location with the provided data
     * @summary create a new location
     * @param {LocationsApiCrmV1LocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1LocationsPost(requestParameters, options) {
        return LocationsApiFp(this.configuration)
            .crmV1LocationsPost(requestParameters.location, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1LocationsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * OrderItemsApi - axios parameter creator
 */
export const OrderItemsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Creates or updates a named one-time charge order item for a service. Ensures each service has at most ONE order item with the given name. The uniqueness is enforced by (siteID, referenceID, name) combination.
         * @summary Create or update a one-time charge order item
         * @param {OrderitemCreateOrUpdateOneTimeChargeRequest} request Create or Update Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderItemsCreateOrUpdateOneTimeChargePost: async (request, options = {}) => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('crmV1OrderItemsCreateOrUpdateOneTimeChargePost', 'request', request);
            const localVarPath = `/crm/v1/order-items/create-or-update-one-time-charge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all order items with optional filtering and sorting
         * @summary List all order items
         * @param {string} [siteID] Filter by site ID
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1OrderItemsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderItemsGet: async (siteID, sortBy, sortDir, options = {}) => {
            const localVarPath = `/crm/v1/order-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (siteID !== undefined) {
                localVarQueryParameter['siteID'] = siteID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an order item by its ID
         * @summary delete order item
         * @param {string} id Order Item ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderItemsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1OrderItemsIdDelete', 'id', id);
            const localVarPath = `/crm/v1/order-items/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing order item
         * @summary update order item
         * @param {string} id Order Item ID
         * @param {ModelOrderItem} orderItem Order Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderItemsIdPut: async (id, orderItem, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1OrderItemsIdPut', 'id', id);
            // verify required parameter 'orderItem' is not null or undefined
            assertParamExists('crmV1OrderItemsIdPut', 'orderItem', orderItem);
            const localVarPath = `/crm/v1/order-items/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new order item
         * @summary create order item
         * @param {ModelOrderItem} orderItem Order Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderItemsPost: async (orderItem, options = {}) => {
            // verify required parameter 'orderItem' is not null or undefined
            assertParamExists('crmV1OrderItemsPost', 'orderItem', orderItem);
            const localVarPath = `/crm/v1/order-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrderItemsApi - functional programming interface
 */
export const OrderItemsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderItemsApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates or updates a named one-time charge order item for a service. Ensures each service has at most ONE order item with the given name. The uniqueness is enforced by (siteID, referenceID, name) combination.
         * @summary Create or update a one-time charge order item
         * @param {OrderitemCreateOrUpdateOneTimeChargeRequest} request Create or Update Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1OrderItemsCreateOrUpdateOneTimeChargePost(request, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1OrderItemsCreateOrUpdateOneTimeChargePost(request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.crmV1OrderItemsCreateOrUpdateOneTimeChargePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all order items with optional filtering and sorting
         * @summary List all order items
         * @param {string} [siteID] Filter by site ID
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1OrderItemsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1OrderItemsGet(siteID, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1OrderItemsGet(siteID, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.crmV1OrderItemsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete an order item by its ID
         * @summary delete order item
         * @param {string} id Order Item ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1OrderItemsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1OrderItemsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.crmV1OrderItemsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing order item
         * @summary update order item
         * @param {string} id Order Item ID
         * @param {ModelOrderItem} orderItem Order Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1OrderItemsIdPut(id, orderItem, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1OrderItemsIdPut(id, orderItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.crmV1OrderItemsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new order item
         * @summary create order item
         * @param {ModelOrderItem} orderItem Order Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1OrderItemsPost(orderItem, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1OrderItemsPost(orderItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.crmV1OrderItemsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrderItemsApi - factory interface
 */
export const OrderItemsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderItemsApiFp(configuration);
    return {
        /**
         * Creates or updates a named one-time charge order item for a service. Ensures each service has at most ONE order item with the given name. The uniqueness is enforced by (siteID, referenceID, name) combination.
         * @summary Create or update a one-time charge order item
         * @param {OrderItemsApiCrmV1OrderItemsCreateOrUpdateOneTimeChargePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderItemsCreateOrUpdateOneTimeChargePost(requestParameters, options) {
            return localVarFp
                .crmV1OrderItemsCreateOrUpdateOneTimeChargePost(requestParameters.request, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get all order items with optional filtering and sorting
         * @summary List all order items
         * @param {OrderItemsApiCrmV1OrderItemsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderItemsGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1OrderItemsGet(requestParameters.siteID, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * delete an order item by its ID
         * @summary delete order item
         * @param {OrderItemsApiCrmV1OrderItemsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderItemsIdDelete(requestParameters, options) {
            return localVarFp.crmV1OrderItemsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing order item
         * @summary update order item
         * @param {OrderItemsApiCrmV1OrderItemsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderItemsIdPut(requestParameters, options) {
            return localVarFp
                .crmV1OrderItemsIdPut(requestParameters.id, requestParameters.orderItem, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new order item
         * @summary create order item
         * @param {OrderItemsApiCrmV1OrderItemsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderItemsPost(requestParameters, options) {
            return localVarFp.crmV1OrderItemsPost(requestParameters.orderItem, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderItemsApi - object-oriented interface
 */
export class OrderItemsApi extends BaseAPI {
    /**
     * Creates or updates a named one-time charge order item for a service. Ensures each service has at most ONE order item with the given name. The uniqueness is enforced by (siteID, referenceID, name) combination.
     * @summary Create or update a one-time charge order item
     * @param {OrderItemsApiCrmV1OrderItemsCreateOrUpdateOneTimeChargePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1OrderItemsCreateOrUpdateOneTimeChargePost(requestParameters, options) {
        return OrderItemsApiFp(this.configuration)
            .crmV1OrderItemsCreateOrUpdateOneTimeChargePost(requestParameters.request, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all order items with optional filtering and sorting
     * @summary List all order items
     * @param {OrderItemsApiCrmV1OrderItemsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1OrderItemsGet(requestParameters = {}, options) {
        return OrderItemsApiFp(this.configuration)
            .crmV1OrderItemsGet(requestParameters.siteID, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete an order item by its ID
     * @summary delete order item
     * @param {OrderItemsApiCrmV1OrderItemsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1OrderItemsIdDelete(requestParameters, options) {
        return OrderItemsApiFp(this.configuration)
            .crmV1OrderItemsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing order item
     * @summary update order item
     * @param {OrderItemsApiCrmV1OrderItemsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1OrderItemsIdPut(requestParameters, options) {
        return OrderItemsApiFp(this.configuration)
            .crmV1OrderItemsIdPut(requestParameters.id, requestParameters.orderItem, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new order item
     * @summary create order item
     * @param {OrderItemsApiCrmV1OrderItemsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1OrderItemsPost(requestParameters, options) {
        return OrderItemsApiFp(this.configuration)
            .crmV1OrderItemsPost(requestParameters.orderItem, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1OrderItemsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * OrderPortaloosApi - axios parameter creator
 */
export const OrderPortaloosApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all order portaloos with optional filtering and sorting
         * @summary List all order portaloos
         * @param {string} [orderPortalooId] Filter by order portaloo ID
         * @param {string} [orderPortalooOrderId] Filter by order ID
         * @param {string} [orderPortalooStatus] Filter by status
         * @param {string} [sortBy] Sort by field (orderPortalooId, orderPortalooOrderId, orderPortalooStatus, orderPortalooStartTimestamp, orderPortalooEndTimestamp, orderPortalooSortOrder, orderPortalooCreatedAt, orderPortalooLastUpdatedAt)
         * @param {CrmV1OrderPortaloosGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderPortaloosGet: async (orderPortalooId, orderPortalooOrderId, orderPortalooStatus, sortBy, sortDir, options = {}) => {
            const localVarPath = `/crm/v1/order-portaloos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (orderPortalooId !== undefined) {
                localVarQueryParameter['orderPortalooId'] = orderPortalooId;
            }
            if (orderPortalooOrderId !== undefined) {
                localVarQueryParameter['orderPortalooOrderId'] = orderPortalooOrderId;
            }
            if (orderPortalooStatus !== undefined) {
                localVarQueryParameter['orderPortalooStatus'] = orderPortalooStatus;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an order portaloo by its ID
         * @summary delete an order portaloo
         * @param {string} id Order Portaloo ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderPortaloosIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1OrderPortaloosIdDelete', 'id', id);
            const localVarPath = `/crm/v1/order-portaloos/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single order portaloo by its ID
         * @summary Get an order portaloo by ID
         * @param {string} id Order Portaloo ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderPortaloosIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1OrderPortaloosIdGet', 'id', id);
            const localVarPath = `/crm/v1/order-portaloos/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing order portaloo with the provided data
         * @summary update an order portaloo
         * @param {string} id Order Portaloo ID
         * @param {ModelOrderPtloo} orderPortaloo Order Portaloo object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderPortaloosIdPut: async (id, orderPortaloo, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1OrderPortaloosIdPut', 'id', id);
            // verify required parameter 'orderPortaloo' is not null or undefined
            assertParamExists('crmV1OrderPortaloosIdPut', 'orderPortaloo', orderPortaloo);
            const localVarPath = `/crm/v1/order-portaloos/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderPortaloo, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new order portaloo
         * @summary create order portaloo
         * @param {ModelOrderPtloo} orderPortaloo Order Portaloo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderPortaloosPost: async (orderPortaloo, options = {}) => {
            // verify required parameter 'orderPortaloo' is not null or undefined
            assertParamExists('crmV1OrderPortaloosPost', 'orderPortaloo', orderPortaloo);
            const localVarPath = `/crm/v1/order-portaloos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderPortaloo, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrderPortaloosApi - functional programming interface
 */
export const OrderPortaloosApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderPortaloosApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all order portaloos with optional filtering and sorting
         * @summary List all order portaloos
         * @param {string} [orderPortalooId] Filter by order portaloo ID
         * @param {string} [orderPortalooOrderId] Filter by order ID
         * @param {string} [orderPortalooStatus] Filter by status
         * @param {string} [sortBy] Sort by field (orderPortalooId, orderPortalooOrderId, orderPortalooStatus, orderPortalooStartTimestamp, orderPortalooEndTimestamp, orderPortalooSortOrder, orderPortalooCreatedAt, orderPortalooLastUpdatedAt)
         * @param {CrmV1OrderPortaloosGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1OrderPortaloosGet(orderPortalooId, orderPortalooOrderId, orderPortalooStatus, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1OrderPortaloosGet(orderPortalooId, orderPortalooOrderId, orderPortalooStatus, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderPortaloosApi.crmV1OrderPortaloosGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete an order portaloo by its ID
         * @summary delete an order portaloo
         * @param {string} id Order Portaloo ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1OrderPortaloosIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1OrderPortaloosIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderPortaloosApi.crmV1OrderPortaloosIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single order portaloo by its ID
         * @summary Get an order portaloo by ID
         * @param {string} id Order Portaloo ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1OrderPortaloosIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1OrderPortaloosIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderPortaloosApi.crmV1OrderPortaloosIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing order portaloo with the provided data
         * @summary update an order portaloo
         * @param {string} id Order Portaloo ID
         * @param {ModelOrderPtloo} orderPortaloo Order Portaloo object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1OrderPortaloosIdPut(id, orderPortaloo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1OrderPortaloosIdPut(id, orderPortaloo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderPortaloosApi.crmV1OrderPortaloosIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new order portaloo
         * @summary create order portaloo
         * @param {ModelOrderPtloo} orderPortaloo Order Portaloo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1OrderPortaloosPost(orderPortaloo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1OrderPortaloosPost(orderPortaloo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderPortaloosApi.crmV1OrderPortaloosPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrderPortaloosApi - factory interface
 */
export const OrderPortaloosApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderPortaloosApiFp(configuration);
    return {
        /**
         * Get all order portaloos with optional filtering and sorting
         * @summary List all order portaloos
         * @param {OrderPortaloosApiCrmV1OrderPortaloosGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderPortaloosGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1OrderPortaloosGet(requestParameters.orderPortalooId, requestParameters.orderPortalooOrderId, requestParameters.orderPortalooStatus, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * delete an order portaloo by its ID
         * @summary delete an order portaloo
         * @param {OrderPortaloosApiCrmV1OrderPortaloosIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderPortaloosIdDelete(requestParameters, options) {
            return localVarFp.crmV1OrderPortaloosIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single order portaloo by its ID
         * @summary Get an order portaloo by ID
         * @param {OrderPortaloosApiCrmV1OrderPortaloosIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderPortaloosIdGet(requestParameters, options) {
            return localVarFp.crmV1OrderPortaloosIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing order portaloo with the provided data
         * @summary update an order portaloo
         * @param {OrderPortaloosApiCrmV1OrderPortaloosIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderPortaloosIdPut(requestParameters, options) {
            return localVarFp
                .crmV1OrderPortaloosIdPut(requestParameters.id, requestParameters.orderPortaloo, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new order portaloo
         * @summary create order portaloo
         * @param {OrderPortaloosApiCrmV1OrderPortaloosPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1OrderPortaloosPost(requestParameters, options) {
            return localVarFp.crmV1OrderPortaloosPost(requestParameters.orderPortaloo, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderPortaloosApi - object-oriented interface
 */
export class OrderPortaloosApi extends BaseAPI {
    /**
     * Get all order portaloos with optional filtering and sorting
     * @summary List all order portaloos
     * @param {OrderPortaloosApiCrmV1OrderPortaloosGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1OrderPortaloosGet(requestParameters = {}, options) {
        return OrderPortaloosApiFp(this.configuration)
            .crmV1OrderPortaloosGet(requestParameters.orderPortalooId, requestParameters.orderPortalooOrderId, requestParameters.orderPortalooStatus, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete an order portaloo by its ID
     * @summary delete an order portaloo
     * @param {OrderPortaloosApiCrmV1OrderPortaloosIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1OrderPortaloosIdDelete(requestParameters, options) {
        return OrderPortaloosApiFp(this.configuration)
            .crmV1OrderPortaloosIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single order portaloo by its ID
     * @summary Get an order portaloo by ID
     * @param {OrderPortaloosApiCrmV1OrderPortaloosIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1OrderPortaloosIdGet(requestParameters, options) {
        return OrderPortaloosApiFp(this.configuration)
            .crmV1OrderPortaloosIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing order portaloo with the provided data
     * @summary update an order portaloo
     * @param {OrderPortaloosApiCrmV1OrderPortaloosIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1OrderPortaloosIdPut(requestParameters, options) {
        return OrderPortaloosApiFp(this.configuration)
            .crmV1OrderPortaloosIdPut(requestParameters.id, requestParameters.orderPortaloo, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new order portaloo
     * @summary create order portaloo
     * @param {OrderPortaloosApiCrmV1OrderPortaloosPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1OrderPortaloosPost(requestParameters, options) {
        return OrderPortaloosApiFp(this.configuration)
            .crmV1OrderPortaloosPost(requestParameters.orderPortaloo, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1OrderPortaloosGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * OtherServicesApi - axios parameter creator
 */
export const OtherServicesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all dealsheet other services with optional filtering and sorting
         * @summary List all dealsheet other services
         * @param {string} [id] Filter by dealsheet other service ID
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {string} [siteID] Filter by site ID (returns only services NOT associated with RFPs)
         * @param {string} [siteIDWithRFP] Filter by site ID (returns only services associated with RFPs)
         * @param {string} [rfpSiteID] Filter by RFP site ID
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1DealsheetOtherServicesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetOtherServicesGet: async (id, dealsheetID, siteID, siteIDWithRFP, rfpSiteID, sortBy, sortDir, limit, offset, options = {}) => {
            const localVarPath = `/crm/v1/dealsheet-other-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (dealsheetID !== undefined) {
                localVarQueryParameter['dealsheetID'] = dealsheetID;
            }
            if (siteID !== undefined) {
                localVarQueryParameter['siteID'] = siteID;
            }
            if (siteIDWithRFP !== undefined) {
                localVarQueryParameter['siteIDWithRFP'] = siteIDWithRFP;
            }
            if (rfpSiteID !== undefined) {
                localVarQueryParameter['rfpSiteID'] = rfpSiteID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a dealsheet other service by its ID
         * @summary Delete a dealsheet other service
         * @param {string} id Dealsheet Other Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetOtherServicesIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetOtherServicesIdDelete', 'id', id);
            const localVarPath = `/crm/v1/dealsheet-other-services/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a copy of an existing other service including all order items with their values. The duplicated service will be on the same site as the source.
         * @summary Duplicate an other service with all order items
         * @param {string} id Source Other Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetOtherServicesIdDuplicatePost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetOtherServicesIdDuplicatePost', 'id', id);
            const localVarPath = `/crm/v1/dealsheet-other-services/{id}/duplicate`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing dealsheet other service with the provided data
         * @summary Update a dealsheet other service
         * @param {string} id Dealsheet Other Service ID
         * @param {ModelOtherService} otherService Dealsheet Other Service object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetOtherServicesIdPut: async (id, otherService, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetOtherServicesIdPut', 'id', id);
            // verify required parameter 'otherService' is not null or undefined
            assertParamExists('crmV1DealsheetOtherServicesIdPut', 'otherService', otherService);
            const localVarPath = `/crm/v1/dealsheet-other-services/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(otherService, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new dealsheet other service
         * @summary Create a dealsheet other service
         * @param {ModelOtherService} otherService Dealsheet Other Service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetOtherServicesPost: async (otherService, options = {}) => {
            // verify required parameter 'otherService' is not null or undefined
            assertParamExists('crmV1DealsheetOtherServicesPost', 'otherService', otherService);
            const localVarPath = `/crm/v1/dealsheet-other-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(otherService, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OtherServicesApi - functional programming interface
 */
export const OtherServicesApiFp = function (configuration) {
    const localVarAxiosParamCreator = OtherServicesApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all dealsheet other services with optional filtering and sorting
         * @summary List all dealsheet other services
         * @param {string} [id] Filter by dealsheet other service ID
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {string} [siteID] Filter by site ID (returns only services NOT associated with RFPs)
         * @param {string} [siteIDWithRFP] Filter by site ID (returns only services associated with RFPs)
         * @param {string} [rfpSiteID] Filter by RFP site ID
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1DealsheetOtherServicesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetOtherServicesGet(id, dealsheetID, siteID, siteIDWithRFP, rfpSiteID, sortBy, sortDir, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetOtherServicesGet(id, dealsheetID, siteID, siteIDWithRFP, rfpSiteID, sortBy, sortDir, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtherServicesApi.crmV1DealsheetOtherServicesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a dealsheet other service by its ID
         * @summary Delete a dealsheet other service
         * @param {string} id Dealsheet Other Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetOtherServicesIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetOtherServicesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtherServicesApi.crmV1DealsheetOtherServicesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a copy of an existing other service including all order items with their values. The duplicated service will be on the same site as the source.
         * @summary Duplicate an other service with all order items
         * @param {string} id Source Other Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetOtherServicesIdDuplicatePost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetOtherServicesIdDuplicatePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtherServicesApi.crmV1DealsheetOtherServicesIdDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing dealsheet other service with the provided data
         * @summary Update a dealsheet other service
         * @param {string} id Dealsheet Other Service ID
         * @param {ModelOtherService} otherService Dealsheet Other Service object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetOtherServicesIdPut(id, otherService, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetOtherServicesIdPut(id, otherService, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtherServicesApi.crmV1DealsheetOtherServicesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new dealsheet other service
         * @summary Create a dealsheet other service
         * @param {ModelOtherService} otherService Dealsheet Other Service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetOtherServicesPost(otherService, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetOtherServicesPost(otherService, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtherServicesApi.crmV1DealsheetOtherServicesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OtherServicesApi - factory interface
 */
export const OtherServicesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OtherServicesApiFp(configuration);
    return {
        /**
         * Get all dealsheet other services with optional filtering and sorting
         * @summary List all dealsheet other services
         * @param {OtherServicesApiCrmV1DealsheetOtherServicesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetOtherServicesGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1DealsheetOtherServicesGet(requestParameters.id, requestParameters.dealsheetID, requestParameters.siteID, requestParameters.siteIDWithRFP, requestParameters.rfpSiteID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.limit, requestParameters.offset, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete a dealsheet other service by its ID
         * @summary Delete a dealsheet other service
         * @param {OtherServicesApiCrmV1DealsheetOtherServicesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetOtherServicesIdDelete(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetOtherServicesIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Creates a copy of an existing other service including all order items with their values. The duplicated service will be on the same site as the source.
         * @summary Duplicate an other service with all order items
         * @param {OtherServicesApiCrmV1DealsheetOtherServicesIdDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetOtherServicesIdDuplicatePost(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetOtherServicesIdDuplicatePost(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update an existing dealsheet other service with the provided data
         * @summary Update a dealsheet other service
         * @param {OtherServicesApiCrmV1DealsheetOtherServicesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetOtherServicesIdPut(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetOtherServicesIdPut(requestParameters.id, requestParameters.otherService, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new dealsheet other service
         * @summary Create a dealsheet other service
         * @param {OtherServicesApiCrmV1DealsheetOtherServicesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetOtherServicesPost(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetOtherServicesPost(requestParameters.otherService, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * OtherServicesApi - object-oriented interface
 */
export class OtherServicesApi extends BaseAPI {
    /**
     * Get all dealsheet other services with optional filtering and sorting
     * @summary List all dealsheet other services
     * @param {OtherServicesApiCrmV1DealsheetOtherServicesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetOtherServicesGet(requestParameters = {}, options) {
        return OtherServicesApiFp(this.configuration)
            .crmV1DealsheetOtherServicesGet(requestParameters.id, requestParameters.dealsheetID, requestParameters.siteID, requestParameters.siteIDWithRFP, requestParameters.rfpSiteID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.limit, requestParameters.offset, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a dealsheet other service by its ID
     * @summary Delete a dealsheet other service
     * @param {OtherServicesApiCrmV1DealsheetOtherServicesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetOtherServicesIdDelete(requestParameters, options) {
        return OtherServicesApiFp(this.configuration)
            .crmV1DealsheetOtherServicesIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a copy of an existing other service including all order items with their values. The duplicated service will be on the same site as the source.
     * @summary Duplicate an other service with all order items
     * @param {OtherServicesApiCrmV1DealsheetOtherServicesIdDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetOtherServicesIdDuplicatePost(requestParameters, options) {
        return OtherServicesApiFp(this.configuration)
            .crmV1DealsheetOtherServicesIdDuplicatePost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing dealsheet other service with the provided data
     * @summary Update a dealsheet other service
     * @param {OtherServicesApiCrmV1DealsheetOtherServicesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetOtherServicesIdPut(requestParameters, options) {
        return OtherServicesApiFp(this.configuration)
            .crmV1DealsheetOtherServicesIdPut(requestParameters.id, requestParameters.otherService, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new dealsheet other service
     * @summary Create a dealsheet other service
     * @param {OtherServicesApiCrmV1DealsheetOtherServicesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetOtherServicesPost(requestParameters, options) {
        return OtherServicesApiFp(this.configuration)
            .crmV1DealsheetOtherServicesPost(requestParameters.otherService, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1DealsheetOtherServicesGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * RfpSitesApi - axios parameter creator
 */
export const RfpSitesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all RFP sites with optional filtering. returns WithProposalDetails with currentPrice, proposedPrice, totalTake, and totalSavings fields.
         * @summary List all RFP sites
         * @param {string} [rfpID] Filter by RFP ID
         * @param {string} [siteID] Filter by site ID
         * @param {string} [vendorID] Filter by vendor ID (filters RFP-sites across all dealsheets by vendor)
         * @param {string} [status] Filter by status (must be a valid RFP site status)
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {CrmV1RfpSitesGetRecommendedEnum} [recommended] Return one proposal per recommended site instead of RFP sites. Requires dealsheetID.
         * @param {CrmV1RfpSitesGetIncludeProposalNumberEnum} [includeProposalNumber] Attach the sequential proposal number (no price aggregates)
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1RfpSitesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesGet: async (rfpID, siteID, vendorID, status, dealsheetID, recommended, includeProposalNumber, sortBy, sortDir, options = {}) => {
            const localVarPath = `/crm/v1/rfp-sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (rfpID !== undefined) {
                localVarQueryParameter['rfpID'] = rfpID;
            }
            if (siteID !== undefined) {
                localVarQueryParameter['siteID'] = siteID;
            }
            if (vendorID !== undefined) {
                localVarQueryParameter['vendorID'] = vendorID;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (dealsheetID !== undefined) {
                localVarQueryParameter['dealsheetID'] = dealsheetID;
            }
            if (recommended !== undefined) {
                localVarQueryParameter['recommended'] = recommended;
            }
            if (includeProposalNumber !== undefined) {
                localVarQueryParameter['includeProposalNumber'] = includeProposalNumber;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Copies the site\'s service lines that this RFP site does not yet carry onto it. Lines added to a site after its RFPs were raised do not reach existing quotes on their own; this is how one vendor\'s quote is brought up to date. Running it twice adds nothing the second time.
         * @summary Add the site\'s missing service lines to this quote
         * @param {string} id RFP Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesIdAddMissingLinesPost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1RfpSitesIdAddMissingLinesPost', 'id', id);
            const localVarPath = `/crm/v1/rfp-sites/{id}/add-missing-lines`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an RFP site relationship by its ID (hard delete, cascades to services)
         * @summary Remove a site from an RFP
         * @param {string} id RFP Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1RfpSitesIdDelete', 'id', id);
            const localVarPath = `/crm/v1/rfp-sites/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves an RFP site with RFP-specific relationships (services, documents, issues). Site-only data (order items, portable toilet orders, service location) is available via siteDetails field. Access pattern: rfpSite.siteDetails.orderPtloo, rfpSite.siteDetails.serviceLocation
         * @summary Get an RFP site by ID
         * @param {string} id RFP Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1RfpSitesIdGet', 'id', id);
            const localVarPath = `/crm/v1/rfp-sites/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an RFP site relationship with the provided data
         * @summary Update an RFP site
         * @param {string} id RFP Site ID
         * @param {ModelRFPSite} rfpSite RFP Site object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesIdPut: async (id, rfpSite, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1RfpSitesIdPut', 'id', id);
            // verify required parameter 'rfpSite' is not null or undefined
            assertParamExists('crmV1RfpSitesIdPut', 'rfpSite', rfpSite);
            const localVarPath = `/crm/v1/rfp-sites/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(rfpSite, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clears the LOA from every line of one vendor\'s quote and drops those lines from the proposal, leaving any other quote at the same site untouched.
         * @summary Take this quote\'s LOA lines back out
         * @param {string} id RFP Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesIdRemoveLoaPost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1RfpSitesIdRemoveLoaPost', 'id', id);
            const localVarPath = `/crm/v1/rfp-sites/{id}/remove-loa`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reverses a DECLINED_TO_QUOTE status on an RFP site, resetting services and re-deriving the correct status
         * @summary Undo a declined RFP site
         * @param {string} id RFP Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesIdUndoDeclinePost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1RfpSitesIdUndoDeclinePost', 'id', id);
            const localVarPath = `/crm/v1/rfp-sites/{id}/undo-decline`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new RFP site relationship
         * @summary Add a site to an RFP
         * @param {ModelRFPSite} rfpSite RFP Site object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesPost: async (rfpSite, options = {}) => {
            // verify required parameter 'rfpSite' is not null or undefined
            assertParamExists('crmV1RfpSitesPost', 'rfpSite', rfpSite);
            const localVarPath = `/crm/v1/rfp-sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(rfpSite, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deal-sheet-wide totals behind the proposal summary cards, built from the same per-proposal figures the list returns. Covers every recommended proposal regardless of paging or filtering, because a total over one page is not a total.
         * @summary Proposal rollup for a deal sheet
         * @param {string} dealsheetID Dealsheet ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesProposalTotalsGet: async (dealsheetID, options = {}) => {
            // verify required parameter 'dealsheetID' is not null or undefined
            assertParamExists('crmV1RfpSitesProposalTotalsGet', 'dealsheetID', dealsheetID);
            const localVarPath = `/crm/v1/rfp-sites/proposal-totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (dealsheetID !== undefined) {
                localVarQueryParameter['dealsheetID'] = dealsheetID;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all commercial and other services for an RFP site with calculated sg_rate, vendor_rate, and delivery fees
         * @summary Get services with calculated rates for an RFP site
         * @param {string} rfpSiteId RFP Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesRfpSiteIdServicesWithDetailsGet: async (rfpSiteId, options = {}) => {
            // verify required parameter 'rfpSiteId' is not null or undefined
            assertParamExists('crmV1RfpSitesRfpSiteIdServicesWithDetailsGet', 'rfpSiteId', rfpSiteId);
            const localVarPath = `/crm/v1/rfp-sites/{rfpSiteId}/services-with-details`.replace('{rfpSiteId}', encodeURIComponent(String(rfpSiteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all sites included in an RFP. Supports same query params as List (e.g. recommended, status).
         * @summary Get sites for an RFP
         * @param {string} rfpId RFP ID
         * @param {CrmV1RfpsRfpIdSitesGetRecommendedEnum} [recommended] Filter to recommended RFP sites only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsRfpIdSitesGet: async (rfpId, recommended, options = {}) => {
            // verify required parameter 'rfpId' is not null or undefined
            assertParamExists('crmV1RfpsRfpIdSitesGet', 'rfpId', rfpId);
            const localVarPath = `/crm/v1/rfps/{rfpId}/sites`.replace('{rfpId}', encodeURIComponent(String(rfpId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (recommended !== undefined) {
                localVarQueryParameter['recommended'] = recommended;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recommendations the given service lines for the site and clears every other recommendation there. Accepts rfpSiteIds instead to recommendation whole quotes.
         * @summary Set RFP sites as recommended for a site
         * @param {string} siteId Site ID
         * @param {RfpsiteRecommendRequest} body Service line IDs to recommendation, or RFP site IDs to recommendation whole. Empty clears every recommendation at the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesSiteIdRfpSitesRecommendPost: async (siteId, body, options = {}) => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('crmV1SitesSiteIdRfpSitesRecommendPost', 'siteId', siteId);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('crmV1SitesSiteIdRfpSitesRecommendPost', 'body', body);
            const localVarPath = `/crm/v1/sites/{siteId}/rfp-sites/recommend`.replace('{siteId}', encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RfpSitesApi - functional programming interface
 */
export const RfpSitesApiFp = function (configuration) {
    const localVarAxiosParamCreator = RfpSitesApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all RFP sites with optional filtering. returns WithProposalDetails with currentPrice, proposedPrice, totalTake, and totalSavings fields.
         * @summary List all RFP sites
         * @param {string} [rfpID] Filter by RFP ID
         * @param {string} [siteID] Filter by site ID
         * @param {string} [vendorID] Filter by vendor ID (filters RFP-sites across all dealsheets by vendor)
         * @param {string} [status] Filter by status (must be a valid RFP site status)
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {CrmV1RfpSitesGetRecommendedEnum} [recommended] Return one proposal per recommended site instead of RFP sites. Requires dealsheetID.
         * @param {CrmV1RfpSitesGetIncludeProposalNumberEnum} [includeProposalNumber] Attach the sequential proposal number (no price aggregates)
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1RfpSitesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpSitesGet(rfpID, siteID, vendorID, status, dealsheetID, recommended, includeProposalNumber, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpSitesGet(rfpID, siteID, vendorID, status, dealsheetID, recommended, includeProposalNumber, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpSitesApi.crmV1RfpSitesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Copies the site\'s service lines that this RFP site does not yet carry onto it. Lines added to a site after its RFPs were raised do not reach existing quotes on their own; this is how one vendor\'s quote is brought up to date. Running it twice adds nothing the second time.
         * @summary Add the site\'s missing service lines to this quote
         * @param {string} id RFP Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpSitesIdAddMissingLinesPost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpSitesIdAddMissingLinesPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpSitesApi.crmV1RfpSitesIdAddMissingLinesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an RFP site relationship by its ID (hard delete, cascades to services)
         * @summary Remove a site from an RFP
         * @param {string} id RFP Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpSitesIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpSitesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpSitesApi.crmV1RfpSitesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves an RFP site with RFP-specific relationships (services, documents, issues). Site-only data (order items, portable toilet orders, service location) is available via siteDetails field. Access pattern: rfpSite.siteDetails.orderPtloo, rfpSite.siteDetails.serviceLocation
         * @summary Get an RFP site by ID
         * @param {string} id RFP Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpSitesIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpSitesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpSitesApi.crmV1RfpSitesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an RFP site relationship with the provided data
         * @summary Update an RFP site
         * @param {string} id RFP Site ID
         * @param {ModelRFPSite} rfpSite RFP Site object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpSitesIdPut(id, rfpSite, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpSitesIdPut(id, rfpSite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpSitesApi.crmV1RfpSitesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clears the LOA from every line of one vendor\'s quote and drops those lines from the proposal, leaving any other quote at the same site untouched.
         * @summary Take this quote\'s LOA lines back out
         * @param {string} id RFP Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpSitesIdRemoveLoaPost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpSitesIdRemoveLoaPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpSitesApi.crmV1RfpSitesIdRemoveLoaPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reverses a DECLINED_TO_QUOTE status on an RFP site, resetting services and re-deriving the correct status
         * @summary Undo a declined RFP site
         * @param {string} id RFP Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpSitesIdUndoDeclinePost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpSitesIdUndoDeclinePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpSitesApi.crmV1RfpSitesIdUndoDeclinePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new RFP site relationship
         * @summary Add a site to an RFP
         * @param {ModelRFPSite} rfpSite RFP Site object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpSitesPost(rfpSite, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpSitesPost(rfpSite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpSitesApi.crmV1RfpSitesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deal-sheet-wide totals behind the proposal summary cards, built from the same per-proposal figures the list returns. Covers every recommended proposal regardless of paging or filtering, because a total over one page is not a total.
         * @summary Proposal rollup for a deal sheet
         * @param {string} dealsheetID Dealsheet ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpSitesProposalTotalsGet(dealsheetID, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpSitesProposalTotalsGet(dealsheetID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpSitesApi.crmV1RfpSitesProposalTotalsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all commercial and other services for an RFP site with calculated sg_rate, vendor_rate, and delivery fees
         * @summary Get services with calculated rates for an RFP site
         * @param {string} rfpSiteId RFP Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpSitesRfpSiteIdServicesWithDetailsGet(rfpSiteId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpSitesRfpSiteIdServicesWithDetailsGet(rfpSiteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpSitesApi.crmV1RfpSitesRfpSiteIdServicesWithDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all sites included in an RFP. Supports same query params as List (e.g. recommended, status).
         * @summary Get sites for an RFP
         * @param {string} rfpId RFP ID
         * @param {CrmV1RfpsRfpIdSitesGetRecommendedEnum} [recommended] Filter to recommended RFP sites only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpsRfpIdSitesGet(rfpId, recommended, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpsRfpIdSitesGet(rfpId, recommended, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpSitesApi.crmV1RfpsRfpIdSitesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Recommendations the given service lines for the site and clears every other recommendation there. Accepts rfpSiteIds instead to recommendation whole quotes.
         * @summary Set RFP sites as recommended for a site
         * @param {string} siteId Site ID
         * @param {RfpsiteRecommendRequest} body Service line IDs to recommendation, or RFP site IDs to recommendation whole. Empty clears every recommendation at the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1SitesSiteIdRfpSitesRecommendPost(siteId, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1SitesSiteIdRfpSitesRecommendPost(siteId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpSitesApi.crmV1SitesSiteIdRfpSitesRecommendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RfpSitesApi - factory interface
 */
export const RfpSitesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RfpSitesApiFp(configuration);
    return {
        /**
         * Get all RFP sites with optional filtering. returns WithProposalDetails with currentPrice, proposedPrice, totalTake, and totalSavings fields.
         * @summary List all RFP sites
         * @param {RfpSitesApiCrmV1RfpSitesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1RfpSitesGet(requestParameters.rfpID, requestParameters.siteID, requestParameters.vendorID, requestParameters.status, requestParameters.dealsheetID, requestParameters.recommended, requestParameters.includeProposalNumber, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Copies the site\'s service lines that this RFP site does not yet carry onto it. Lines added to a site after its RFPs were raised do not reach existing quotes on their own; this is how one vendor\'s quote is brought up to date. Running it twice adds nothing the second time.
         * @summary Add the site\'s missing service lines to this quote
         * @param {RfpSitesApiCrmV1RfpSitesIdAddMissingLinesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesIdAddMissingLinesPost(requestParameters, options) {
            return localVarFp.crmV1RfpSitesIdAddMissingLinesPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an RFP site relationship by its ID (hard delete, cascades to services)
         * @summary Remove a site from an RFP
         * @param {RfpSitesApiCrmV1RfpSitesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesIdDelete(requestParameters, options) {
            return localVarFp.crmV1RfpSitesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves an RFP site with RFP-specific relationships (services, documents, issues). Site-only data (order items, portable toilet orders, service location) is available via siteDetails field. Access pattern: rfpSite.siteDetails.orderPtloo, rfpSite.siteDetails.serviceLocation
         * @summary Get an RFP site by ID
         * @param {RfpSitesApiCrmV1RfpSitesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesIdGet(requestParameters, options) {
            return localVarFp.crmV1RfpSitesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an RFP site relationship with the provided data
         * @summary Update an RFP site
         * @param {RfpSitesApiCrmV1RfpSitesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesIdPut(requestParameters, options) {
            return localVarFp
                .crmV1RfpSitesIdPut(requestParameters.id, requestParameters.rfpSite, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Clears the LOA from every line of one vendor\'s quote and drops those lines from the proposal, leaving any other quote at the same site untouched.
         * @summary Take this quote\'s LOA lines back out
         * @param {RfpSitesApiCrmV1RfpSitesIdRemoveLoaPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesIdRemoveLoaPost(requestParameters, options) {
            return localVarFp.crmV1RfpSitesIdRemoveLoaPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Reverses a DECLINED_TO_QUOTE status on an RFP site, resetting services and re-deriving the correct status
         * @summary Undo a declined RFP site
         * @param {RfpSitesApiCrmV1RfpSitesIdUndoDeclinePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesIdUndoDeclinePost(requestParameters, options) {
            return localVarFp.crmV1RfpSitesIdUndoDeclinePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new RFP site relationship
         * @summary Add a site to an RFP
         * @param {RfpSitesApiCrmV1RfpSitesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesPost(requestParameters, options) {
            return localVarFp.crmV1RfpSitesPost(requestParameters.rfpSite, options).then((request) => request(axios, basePath));
        },
        /**
         * Deal-sheet-wide totals behind the proposal summary cards, built from the same per-proposal figures the list returns. Covers every recommended proposal regardless of paging or filtering, because a total over one page is not a total.
         * @summary Proposal rollup for a deal sheet
         * @param {RfpSitesApiCrmV1RfpSitesProposalTotalsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesProposalTotalsGet(requestParameters, options) {
            return localVarFp
                .crmV1RfpSitesProposalTotalsGet(requestParameters.dealsheetID, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all commercial and other services for an RFP site with calculated sg_rate, vendor_rate, and delivery fees
         * @summary Get services with calculated rates for an RFP site
         * @param {RfpSitesApiCrmV1RfpSitesRfpSiteIdServicesWithDetailsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpSitesRfpSiteIdServicesWithDetailsGet(requestParameters, options) {
            return localVarFp
                .crmV1RfpSitesRfpSiteIdServicesWithDetailsGet(requestParameters.rfpSiteId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get all sites included in an RFP. Supports same query params as List (e.g. recommended, status).
         * @summary Get sites for an RFP
         * @param {RfpSitesApiCrmV1RfpsRfpIdSitesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsRfpIdSitesGet(requestParameters, options) {
            return localVarFp
                .crmV1RfpsRfpIdSitesGet(requestParameters.rfpId, requestParameters.recommended, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Recommendations the given service lines for the site and clears every other recommendation there. Accepts rfpSiteIds instead to recommendation whole quotes.
         * @summary Set RFP sites as recommended for a site
         * @param {RfpSitesApiCrmV1SitesSiteIdRfpSitesRecommendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesSiteIdRfpSitesRecommendPost(requestParameters, options) {
            return localVarFp
                .crmV1SitesSiteIdRfpSitesRecommendPost(requestParameters.siteId, requestParameters.body, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * RfpSitesApi - object-oriented interface
 */
export class RfpSitesApi extends BaseAPI {
    /**
     * Get all RFP sites with optional filtering. returns WithProposalDetails with currentPrice, proposedPrice, totalTake, and totalSavings fields.
     * @summary List all RFP sites
     * @param {RfpSitesApiCrmV1RfpSitesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpSitesGet(requestParameters = {}, options) {
        return RfpSitesApiFp(this.configuration)
            .crmV1RfpSitesGet(requestParameters.rfpID, requestParameters.siteID, requestParameters.vendorID, requestParameters.status, requestParameters.dealsheetID, requestParameters.recommended, requestParameters.includeProposalNumber, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Copies the site\'s service lines that this RFP site does not yet carry onto it. Lines added to a site after its RFPs were raised do not reach existing quotes on their own; this is how one vendor\'s quote is brought up to date. Running it twice adds nothing the second time.
     * @summary Add the site\'s missing service lines to this quote
     * @param {RfpSitesApiCrmV1RfpSitesIdAddMissingLinesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpSitesIdAddMissingLinesPost(requestParameters, options) {
        return RfpSitesApiFp(this.configuration)
            .crmV1RfpSitesIdAddMissingLinesPost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete an RFP site relationship by its ID (hard delete, cascades to services)
     * @summary Remove a site from an RFP
     * @param {RfpSitesApiCrmV1RfpSitesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpSitesIdDelete(requestParameters, options) {
        return RfpSitesApiFp(this.configuration)
            .crmV1RfpSitesIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves an RFP site with RFP-specific relationships (services, documents, issues). Site-only data (order items, portable toilet orders, service location) is available via siteDetails field. Access pattern: rfpSite.siteDetails.orderPtloo, rfpSite.siteDetails.serviceLocation
     * @summary Get an RFP site by ID
     * @param {RfpSitesApiCrmV1RfpSitesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpSitesIdGet(requestParameters, options) {
        return RfpSitesApiFp(this.configuration)
            .crmV1RfpSitesIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an RFP site relationship with the provided data
     * @summary Update an RFP site
     * @param {RfpSitesApiCrmV1RfpSitesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpSitesIdPut(requestParameters, options) {
        return RfpSitesApiFp(this.configuration)
            .crmV1RfpSitesIdPut(requestParameters.id, requestParameters.rfpSite, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Clears the LOA from every line of one vendor\'s quote and drops those lines from the proposal, leaving any other quote at the same site untouched.
     * @summary Take this quote\'s LOA lines back out
     * @param {RfpSitesApiCrmV1RfpSitesIdRemoveLoaPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpSitesIdRemoveLoaPost(requestParameters, options) {
        return RfpSitesApiFp(this.configuration)
            .crmV1RfpSitesIdRemoveLoaPost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Reverses a DECLINED_TO_QUOTE status on an RFP site, resetting services and re-deriving the correct status
     * @summary Undo a declined RFP site
     * @param {RfpSitesApiCrmV1RfpSitesIdUndoDeclinePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpSitesIdUndoDeclinePost(requestParameters, options) {
        return RfpSitesApiFp(this.configuration)
            .crmV1RfpSitesIdUndoDeclinePost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new RFP site relationship
     * @summary Add a site to an RFP
     * @param {RfpSitesApiCrmV1RfpSitesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpSitesPost(requestParameters, options) {
        return RfpSitesApiFp(this.configuration)
            .crmV1RfpSitesPost(requestParameters.rfpSite, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deal-sheet-wide totals behind the proposal summary cards, built from the same per-proposal figures the list returns. Covers every recommended proposal regardless of paging or filtering, because a total over one page is not a total.
     * @summary Proposal rollup for a deal sheet
     * @param {RfpSitesApiCrmV1RfpSitesProposalTotalsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpSitesProposalTotalsGet(requestParameters, options) {
        return RfpSitesApiFp(this.configuration)
            .crmV1RfpSitesProposalTotalsGet(requestParameters.dealsheetID, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves all commercial and other services for an RFP site with calculated sg_rate, vendor_rate, and delivery fees
     * @summary Get services with calculated rates for an RFP site
     * @param {RfpSitesApiCrmV1RfpSitesRfpSiteIdServicesWithDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpSitesRfpSiteIdServicesWithDetailsGet(requestParameters, options) {
        return RfpSitesApiFp(this.configuration)
            .crmV1RfpSitesRfpSiteIdServicesWithDetailsGet(requestParameters.rfpSiteId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all sites included in an RFP. Supports same query params as List (e.g. recommended, status).
     * @summary Get sites for an RFP
     * @param {RfpSitesApiCrmV1RfpsRfpIdSitesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpsRfpIdSitesGet(requestParameters, options) {
        return RfpSitesApiFp(this.configuration)
            .crmV1RfpsRfpIdSitesGet(requestParameters.rfpId, requestParameters.recommended, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Recommendations the given service lines for the site and clears every other recommendation there. Accepts rfpSiteIds instead to recommendation whole quotes.
     * @summary Set RFP sites as recommended for a site
     * @param {RfpSitesApiCrmV1SitesSiteIdRfpSitesRecommendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1SitesSiteIdRfpSitesRecommendPost(requestParameters, options) {
        return RfpSitesApiFp(this.configuration)
            .crmV1SitesSiteIdRfpSitesRecommendPost(requestParameters.siteId, requestParameters.body, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1RfpSitesGetRecommendedEnum = {
    True: 'true',
    False: 'false',
};
export const CrmV1RfpSitesGetIncludeProposalNumberEnum = {
    True: 'true',
    False: 'false',
};
export const CrmV1RfpSitesGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
export const CrmV1RfpsRfpIdSitesGetRecommendedEnum = {
    True: 'true',
    False: 'false',
};
/**
 * RfpsApi - axios parameter creator
 */
export const RfpsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all RFPs associated with a dealsheet, with sites and services populated
         * @summary Get all RFPs for a dealsheet
         * @param {string} dealsheetID Dealsheet ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetsDealsheetIDRfpsGet: async (dealsheetID, options = {}) => {
            // verify required parameter 'dealsheetID' is not null or undefined
            assertParamExists('crmV1DealsheetsDealsheetIDRfpsGet', 'dealsheetID', dealsheetID);
            const localVarPath = `/crm/v1/dealsheets/{dealsheetID}/rfps`.replace('{dealsheetID}', encodeURIComponent(String(dealsheetID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Per-vendor RFP responsiveness counts at the requested grain; callers derive any rate as responded/total. grain=RFP (default): total = non-deleted RFPs for the vendor, responded = RFPs with at least one quoted site (status not PENDING_RESPONSE/DECLINED_TO_QUOTE; a decline is a miss) — powers the CreateRFP modal completion rate. grain=RFP_SITE: total = evaluable rfp_site rows, responded = on-time sites under the deadline-aware rule (a timely decline counts as on-time) — powers SourScore\'s COMMERCIAL_RFP_RESPONSE inputs (total, onTime). Pass multiple vendorID params to batch; an optional [windowStart, windowEnd] window filters by created_at (omit for lifetime).
         * @summary RFP responsiveness counts for one or more vendors
         * @param {Array<string>} vendorID Vendor ID (UUID); repeat for multiple vendors (e.g. vendorID&#x3D;id1&amp;vendorID&#x3D;id2)
         * @param {CrmV1RfpsCountsGetGrainEnum} [grain] Counting grain
         * @param {string} [windowStart] Window start (RFC3339 or yyyy-MM-dd); omit for lifetime
         * @param {string} [windowEnd] Window end (RFC3339 or yyyy-MM-dd); omit for now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsCountsGet: async (vendorID, grain, windowStart, windowEnd, options = {}) => {
            // verify required parameter 'vendorID' is not null or undefined
            assertParamExists('crmV1RfpsCountsGet', 'vendorID', vendorID);
            const localVarPath = `/crm/v1/rfps/counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (vendorID) {
                localVarQueryParameter['vendorID'] = vendorID;
            }
            if (grain !== undefined) {
                localVarQueryParameter['grain'] = grain;
            }
            if (windowStart !== undefined) {
                localVarQueryParameter['windowStart'] = windowStart;
            }
            if (windowEnd !== undefined) {
                localVarQueryParameter['windowEnd'] = windowEnd;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all RFPs with optional filtering by dealsheet, vendor, etc.
         * @summary List all RFPs
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {string} [vendorID] Filter by vendor ID
         * @param {CrmV1RfpsGetDeletedEnum} [deleted] Include deleted RFPs
         * @param {CrmV1RfpsGetSortByEnum} [sortBy] Sort field
         * @param {CrmV1RfpsGetSortDirEnum} [sortDir] Sort direction
         * @param {number} [limit] Page size
         * @param {number} [offset] Page offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsGet: async (dealsheetID, vendorID, deleted, sortBy, sortDir, limit, offset, options = {}) => {
            const localVarPath = `/crm/v1/rfps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (dealsheetID !== undefined) {
                localVarQueryParameter['dealsheetID'] = dealsheetID;
            }
            if (vendorID !== undefined) {
                localVarQueryParameter['vendorID'] = vendorID;
            }
            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete an RFP by its ID
         * @summary Delete an RFP
         * @param {string} id RFP ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1RfpsIdDelete', 'id', id);
            const localVarPath = `/crm/v1/rfps/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single RFP by its ID with all sites and services populated
         * @summary Get an RFP by ID
         * @param {string} id RFP ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1RfpsIdGet', 'id', id);
            const localVarPath = `/crm/v1/rfps/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends the vendor-rfp email for an already-existing RFP and persists the sent timestamp. This is distinct from CreateRFPs (POST /rfps), which creates RFP records and optionally emails in one shot. This endpoint is for triggering (or re-triggering) the email on an existing RFP without creating a duplicate record — e.g. from the vendor table \"Send RFP email\" action.
         * @summary Send RFP email to vendor
         * @param {string} id RFP ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsIdSendEmailPost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1RfpsIdSendEmailPost', 'id', id);
            const localVarPath = `/crm/v1/rfps/{id}/send-email`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create RFPs for one or more vendors with multiple sites. If services are provided for a site, they are used; otherwise existing site services are duplicated.
         * @summary Create RFPs for one or more vendors
         * @param {ModelCreateRFPRequest} request Create RFP request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsPost: async (request, options = {}) => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('crmV1RfpsPost', 'request', request);
            const localVarPath = `/crm/v1/rfps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RfpsApi - functional programming interface
 */
export const RfpsApiFp = function (configuration) {
    const localVarAxiosParamCreator = RfpsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all RFPs associated with a dealsheet, with sites and services populated
         * @summary Get all RFPs for a dealsheet
         * @param {string} dealsheetID Dealsheet ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetsDealsheetIDRfpsGet(dealsheetID, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetsDealsheetIDRfpsGet(dealsheetID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpsApi.crmV1DealsheetsDealsheetIDRfpsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Per-vendor RFP responsiveness counts at the requested grain; callers derive any rate as responded/total. grain=RFP (default): total = non-deleted RFPs for the vendor, responded = RFPs with at least one quoted site (status not PENDING_RESPONSE/DECLINED_TO_QUOTE; a decline is a miss) — powers the CreateRFP modal completion rate. grain=RFP_SITE: total = evaluable rfp_site rows, responded = on-time sites under the deadline-aware rule (a timely decline counts as on-time) — powers SourScore\'s COMMERCIAL_RFP_RESPONSE inputs (total, onTime). Pass multiple vendorID params to batch; an optional [windowStart, windowEnd] window filters by created_at (omit for lifetime).
         * @summary RFP responsiveness counts for one or more vendors
         * @param {Array<string>} vendorID Vendor ID (UUID); repeat for multiple vendors (e.g. vendorID&#x3D;id1&amp;vendorID&#x3D;id2)
         * @param {CrmV1RfpsCountsGetGrainEnum} [grain] Counting grain
         * @param {string} [windowStart] Window start (RFC3339 or yyyy-MM-dd); omit for lifetime
         * @param {string} [windowEnd] Window end (RFC3339 or yyyy-MM-dd); omit for now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpsCountsGet(vendorID, grain, windowStart, windowEnd, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpsCountsGet(vendorID, grain, windowStart, windowEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpsApi.crmV1RfpsCountsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all RFPs with optional filtering by dealsheet, vendor, etc.
         * @summary List all RFPs
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {string} [vendorID] Filter by vendor ID
         * @param {CrmV1RfpsGetDeletedEnum} [deleted] Include deleted RFPs
         * @param {CrmV1RfpsGetSortByEnum} [sortBy] Sort field
         * @param {CrmV1RfpsGetSortDirEnum} [sortDir] Sort direction
         * @param {number} [limit] Page size
         * @param {number} [offset] Page offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpsGet(dealsheetID, vendorID, deleted, sortBy, sortDir, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpsGet(dealsheetID, vendorID, deleted, sortBy, sortDir, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpsApi.crmV1RfpsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft-delete an RFP by its ID
         * @summary Delete an RFP
         * @param {string} id RFP ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpsApi.crmV1RfpsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single RFP by its ID with all sites and services populated
         * @summary Get an RFP by ID
         * @param {string} id RFP ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpsApi.crmV1RfpsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends the vendor-rfp email for an already-existing RFP and persists the sent timestamp. This is distinct from CreateRFPs (POST /rfps), which creates RFP records and optionally emails in one shot. This endpoint is for triggering (or re-triggering) the email on an existing RFP without creating a duplicate record — e.g. from the vendor table \"Send RFP email\" action.
         * @summary Send RFP email to vendor
         * @param {string} id RFP ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpsIdSendEmailPost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpsIdSendEmailPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpsApi.crmV1RfpsIdSendEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create RFPs for one or more vendors with multiple sites. If services are provided for a site, they are used; otherwise existing site services are duplicated.
         * @summary Create RFPs for one or more vendors
         * @param {ModelCreateRFPRequest} request Create RFP request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1RfpsPost(request, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1RfpsPost(request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RfpsApi.crmV1RfpsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RfpsApi - factory interface
 */
export const RfpsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RfpsApiFp(configuration);
    return {
        /**
         * Get all RFPs associated with a dealsheet, with sites and services populated
         * @summary Get all RFPs for a dealsheet
         * @param {RfpsApiCrmV1DealsheetsDealsheetIDRfpsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetsDealsheetIDRfpsGet(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetsDealsheetIDRfpsGet(requestParameters.dealsheetID, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Per-vendor RFP responsiveness counts at the requested grain; callers derive any rate as responded/total. grain=RFP (default): total = non-deleted RFPs for the vendor, responded = RFPs with at least one quoted site (status not PENDING_RESPONSE/DECLINED_TO_QUOTE; a decline is a miss) — powers the CreateRFP modal completion rate. grain=RFP_SITE: total = evaluable rfp_site rows, responded = on-time sites under the deadline-aware rule (a timely decline counts as on-time) — powers SourScore\'s COMMERCIAL_RFP_RESPONSE inputs (total, onTime). Pass multiple vendorID params to batch; an optional [windowStart, windowEnd] window filters by created_at (omit for lifetime).
         * @summary RFP responsiveness counts for one or more vendors
         * @param {RfpsApiCrmV1RfpsCountsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsCountsGet(requestParameters, options) {
            return localVarFp
                .crmV1RfpsCountsGet(requestParameters.vendorID, requestParameters.grain, requestParameters.windowStart, requestParameters.windowEnd, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get all RFPs with optional filtering by dealsheet, vendor, etc.
         * @summary List all RFPs
         * @param {RfpsApiCrmV1RfpsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1RfpsGet(requestParameters.dealsheetID, requestParameters.vendorID, requestParameters.deleted, requestParameters.sortBy, requestParameters.sortDir, requestParameters.limit, requestParameters.offset, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete an RFP by its ID
         * @summary Delete an RFP
         * @param {RfpsApiCrmV1RfpsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsIdDelete(requestParameters, options) {
            return localVarFp.crmV1RfpsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single RFP by its ID with all sites and services populated
         * @summary Get an RFP by ID
         * @param {RfpsApiCrmV1RfpsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsIdGet(requestParameters, options) {
            return localVarFp.crmV1RfpsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends the vendor-rfp email for an already-existing RFP and persists the sent timestamp. This is distinct from CreateRFPs (POST /rfps), which creates RFP records and optionally emails in one shot. This endpoint is for triggering (or re-triggering) the email on an existing RFP without creating a duplicate record — e.g. from the vendor table \"Send RFP email\" action.
         * @summary Send RFP email to vendor
         * @param {RfpsApiCrmV1RfpsIdSendEmailPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsIdSendEmailPost(requestParameters, options) {
            return localVarFp.crmV1RfpsIdSendEmailPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create RFPs for one or more vendors with multiple sites. If services are provided for a site, they are used; otherwise existing site services are duplicated.
         * @summary Create RFPs for one or more vendors
         * @param {RfpsApiCrmV1RfpsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1RfpsPost(requestParameters, options) {
            return localVarFp.crmV1RfpsPost(requestParameters.request, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RfpsApi - object-oriented interface
 */
export class RfpsApi extends BaseAPI {
    /**
     * Get all RFPs associated with a dealsheet, with sites and services populated
     * @summary Get all RFPs for a dealsheet
     * @param {RfpsApiCrmV1DealsheetsDealsheetIDRfpsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetsDealsheetIDRfpsGet(requestParameters, options) {
        return RfpsApiFp(this.configuration)
            .crmV1DealsheetsDealsheetIDRfpsGet(requestParameters.dealsheetID, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Per-vendor RFP responsiveness counts at the requested grain; callers derive any rate as responded/total. grain=RFP (default): total = non-deleted RFPs for the vendor, responded = RFPs with at least one quoted site (status not PENDING_RESPONSE/DECLINED_TO_QUOTE; a decline is a miss) — powers the CreateRFP modal completion rate. grain=RFP_SITE: total = evaluable rfp_site rows, responded = on-time sites under the deadline-aware rule (a timely decline counts as on-time) — powers SourScore\'s COMMERCIAL_RFP_RESPONSE inputs (total, onTime). Pass multiple vendorID params to batch; an optional [windowStart, windowEnd] window filters by created_at (omit for lifetime).
     * @summary RFP responsiveness counts for one or more vendors
     * @param {RfpsApiCrmV1RfpsCountsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpsCountsGet(requestParameters, options) {
        return RfpsApiFp(this.configuration)
            .crmV1RfpsCountsGet(requestParameters.vendorID, requestParameters.grain, requestParameters.windowStart, requestParameters.windowEnd, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all RFPs with optional filtering by dealsheet, vendor, etc.
     * @summary List all RFPs
     * @param {RfpsApiCrmV1RfpsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpsGet(requestParameters = {}, options) {
        return RfpsApiFp(this.configuration)
            .crmV1RfpsGet(requestParameters.dealsheetID, requestParameters.vendorID, requestParameters.deleted, requestParameters.sortBy, requestParameters.sortDir, requestParameters.limit, requestParameters.offset, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Soft-delete an RFP by its ID
     * @summary Delete an RFP
     * @param {RfpsApiCrmV1RfpsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpsIdDelete(requestParameters, options) {
        return RfpsApiFp(this.configuration)
            .crmV1RfpsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single RFP by its ID with all sites and services populated
     * @summary Get an RFP by ID
     * @param {RfpsApiCrmV1RfpsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpsIdGet(requestParameters, options) {
        return RfpsApiFp(this.configuration)
            .crmV1RfpsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sends the vendor-rfp email for an already-existing RFP and persists the sent timestamp. This is distinct from CreateRFPs (POST /rfps), which creates RFP records and optionally emails in one shot. This endpoint is for triggering (or re-triggering) the email on an existing RFP without creating a duplicate record — e.g. from the vendor table \"Send RFP email\" action.
     * @summary Send RFP email to vendor
     * @param {RfpsApiCrmV1RfpsIdSendEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpsIdSendEmailPost(requestParameters, options) {
        return RfpsApiFp(this.configuration)
            .crmV1RfpsIdSendEmailPost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create RFPs for one or more vendors with multiple sites. If services are provided for a site, they are used; otherwise existing site services are duplicated.
     * @summary Create RFPs for one or more vendors
     * @param {RfpsApiCrmV1RfpsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1RfpsPost(requestParameters, options) {
        return RfpsApiFp(this.configuration)
            .crmV1RfpsPost(requestParameters.request, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1RfpsCountsGetGrainEnum = {
    Rfp: 'RFP',
    RfpSite: 'RFP_SITE',
};
export const CrmV1RfpsGetDeletedEnum = {
    True: 'true',
    False: 'false',
};
export const CrmV1RfpsGetSortByEnum = {
    CreatedAt: 'createdAt',
};
export const CrmV1RfpsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * RollOffServicesApi - axios parameter creator
 */
export const RollOffServicesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all dealsheet roll-off services with optional filtering and sorting
         * @summary List all dealsheet roll-off services
         * @param {string} [id] Filter by dealsheet roll-off service ID
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {string} [siteID] Filter by site ID (returns only services NOT associated with RFPs)
         * @param {string} [siteIDWithRFP] Filter by site ID (returns only services associated with RFPs)
         * @param {string} [rfpSiteID] Filter by RFP site ID
         * @param {CrmV1DealsheetRollOffServicesGetWithRatesEnum} [withRates] Include derived monthly rate, cost and volume basis
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1DealsheetRollOffServicesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetRollOffServicesGet: async (id, dealsheetID, siteID, siteIDWithRFP, rfpSiteID, withRates, sortBy, sortDir, limit, offset, options = {}) => {
            const localVarPath = `/crm/v1/dealsheet-roll-off-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (dealsheetID !== undefined) {
                localVarQueryParameter['dealsheetID'] = dealsheetID;
            }
            if (siteID !== undefined) {
                localVarQueryParameter['siteID'] = siteID;
            }
            if (siteIDWithRFP !== undefined) {
                localVarQueryParameter['siteIDWithRFP'] = siteIDWithRFP;
            }
            if (rfpSiteID !== undefined) {
                localVarQueryParameter['rfpSiteID'] = rfpSiteID;
            }
            if (withRates !== undefined) {
                localVarQueryParameter['withRates'] = withRates;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a dealsheet roll-off service by its ID
         * @summary Delete a dealsheet roll-off service
         * @param {string} id Dealsheet Roll-Off Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetRollOffServicesIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetRollOffServicesIdDelete', 'id', id);
            const localVarPath = `/crm/v1/dealsheet-roll-off-services/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a copy of an existing roll-off service including all order items with their values. The duplicated service will be on the same site as the source.
         * @summary Duplicate a roll-off service with all order items
         * @param {string} id Source Roll-Off Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetRollOffServicesIdDuplicatePost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetRollOffServicesIdDuplicatePost', 'id', id);
            const localVarPath = `/crm/v1/dealsheet-roll-off-services/{id}/duplicate`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing dealsheet roll-off service with the provided data
         * @summary Update a dealsheet roll-off service
         * @param {string} id Dealsheet Roll-Off Service ID
         * @param {ModelRollOffService} rollOffService Dealsheet Roll-Off Service object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetRollOffServicesIdPut: async (id, rollOffService, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetRollOffServicesIdPut', 'id', id);
            // verify required parameter 'rollOffService' is not null or undefined
            assertParamExists('crmV1DealsheetRollOffServicesIdPut', 'rollOffService', rollOffService);
            const localVarPath = `/crm/v1/dealsheet-roll-off-services/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(rollOffService, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Runs the roll-off rate formula backwards: given a target monthly rate, derives haul, dump and overage from the vendor\'s cost structure (or the incumbent\'s, before a vendor has quoted) and persists them. Roll-off has no single unit rate, so a target cannot be written to one column.
         * @summary Rebuild a roll-off line\'s rates to hit a monthly figure
         * @param {string} id Dealsheet Roll-Off Service ID
         * @param {RolloffserviceTargetMonthlyRequest} target Target monthly rate in cents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetRollOffServicesIdTargetMonthlyPut: async (id, target, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1DealsheetRollOffServicesIdTargetMonthlyPut', 'id', id);
            // verify required parameter 'target' is not null or undefined
            assertParamExists('crmV1DealsheetRollOffServicesIdTargetMonthlyPut', 'target', target);
            const localVarPath = `/crm/v1/dealsheet-roll-off-services/{id}/target-monthly`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(target, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new dealsheet roll-off service
         * @summary Create a dealsheet roll-off service
         * @param {ModelRollOffService} rollOffService Dealsheet Roll-Off Service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetRollOffServicesPost: async (rollOffService, options = {}) => {
            // verify required parameter 'rollOffService' is not null or undefined
            assertParamExists('crmV1DealsheetRollOffServicesPost', 'rollOffService', rollOffService);
            const localVarPath = `/crm/v1/dealsheet-roll-off-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(rollOffService, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RollOffServicesApi - functional programming interface
 */
export const RollOffServicesApiFp = function (configuration) {
    const localVarAxiosParamCreator = RollOffServicesApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all dealsheet roll-off services with optional filtering and sorting
         * @summary List all dealsheet roll-off services
         * @param {string} [id] Filter by dealsheet roll-off service ID
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {string} [siteID] Filter by site ID (returns only services NOT associated with RFPs)
         * @param {string} [siteIDWithRFP] Filter by site ID (returns only services associated with RFPs)
         * @param {string} [rfpSiteID] Filter by RFP site ID
         * @param {CrmV1DealsheetRollOffServicesGetWithRatesEnum} [withRates] Include derived monthly rate, cost and volume basis
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1DealsheetRollOffServicesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetRollOffServicesGet(id, dealsheetID, siteID, siteIDWithRFP, rfpSiteID, withRates, sortBy, sortDir, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetRollOffServicesGet(id, dealsheetID, siteID, siteIDWithRFP, rfpSiteID, withRates, sortBy, sortDir, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RollOffServicesApi.crmV1DealsheetRollOffServicesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a dealsheet roll-off service by its ID
         * @summary Delete a dealsheet roll-off service
         * @param {string} id Dealsheet Roll-Off Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetRollOffServicesIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetRollOffServicesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RollOffServicesApi.crmV1DealsheetRollOffServicesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a copy of an existing roll-off service including all order items with their values. The duplicated service will be on the same site as the source.
         * @summary Duplicate a roll-off service with all order items
         * @param {string} id Source Roll-Off Service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetRollOffServicesIdDuplicatePost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetRollOffServicesIdDuplicatePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RollOffServicesApi.crmV1DealsheetRollOffServicesIdDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing dealsheet roll-off service with the provided data
         * @summary Update a dealsheet roll-off service
         * @param {string} id Dealsheet Roll-Off Service ID
         * @param {ModelRollOffService} rollOffService Dealsheet Roll-Off Service object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetRollOffServicesIdPut(id, rollOffService, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetRollOffServicesIdPut(id, rollOffService, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RollOffServicesApi.crmV1DealsheetRollOffServicesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Runs the roll-off rate formula backwards: given a target monthly rate, derives haul, dump and overage from the vendor\'s cost structure (or the incumbent\'s, before a vendor has quoted) and persists them. Roll-off has no single unit rate, so a target cannot be written to one column.
         * @summary Rebuild a roll-off line\'s rates to hit a monthly figure
         * @param {string} id Dealsheet Roll-Off Service ID
         * @param {RolloffserviceTargetMonthlyRequest} target Target monthly rate in cents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetRollOffServicesIdTargetMonthlyPut(id, target, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetRollOffServicesIdTargetMonthlyPut(id, target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RollOffServicesApi.crmV1DealsheetRollOffServicesIdTargetMonthlyPut']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new dealsheet roll-off service
         * @summary Create a dealsheet roll-off service
         * @param {ModelRollOffService} rollOffService Dealsheet Roll-Off Service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1DealsheetRollOffServicesPost(rollOffService, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1DealsheetRollOffServicesPost(rollOffService, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RollOffServicesApi.crmV1DealsheetRollOffServicesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RollOffServicesApi - factory interface
 */
export const RollOffServicesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RollOffServicesApiFp(configuration);
    return {
        /**
         * Get all dealsheet roll-off services with optional filtering and sorting
         * @summary List all dealsheet roll-off services
         * @param {RollOffServicesApiCrmV1DealsheetRollOffServicesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetRollOffServicesGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1DealsheetRollOffServicesGet(requestParameters.id, requestParameters.dealsheetID, requestParameters.siteID, requestParameters.siteIDWithRFP, requestParameters.rfpSiteID, requestParameters.withRates, requestParameters.sortBy, requestParameters.sortDir, requestParameters.limit, requestParameters.offset, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete a dealsheet roll-off service by its ID
         * @summary Delete a dealsheet roll-off service
         * @param {RollOffServicesApiCrmV1DealsheetRollOffServicesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetRollOffServicesIdDelete(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetRollOffServicesIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Creates a copy of an existing roll-off service including all order items with their values. The duplicated service will be on the same site as the source.
         * @summary Duplicate a roll-off service with all order items
         * @param {RollOffServicesApiCrmV1DealsheetRollOffServicesIdDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetRollOffServicesIdDuplicatePost(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetRollOffServicesIdDuplicatePost(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update an existing dealsheet roll-off service with the provided data
         * @summary Update a dealsheet roll-off service
         * @param {RollOffServicesApiCrmV1DealsheetRollOffServicesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetRollOffServicesIdPut(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetRollOffServicesIdPut(requestParameters.id, requestParameters.rollOffService, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Runs the roll-off rate formula backwards: given a target monthly rate, derives haul, dump and overage from the vendor\'s cost structure (or the incumbent\'s, before a vendor has quoted) and persists them. Roll-off has no single unit rate, so a target cannot be written to one column.
         * @summary Rebuild a roll-off line\'s rates to hit a monthly figure
         * @param {RollOffServicesApiCrmV1DealsheetRollOffServicesIdTargetMonthlyPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetRollOffServicesIdTargetMonthlyPut(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetRollOffServicesIdTargetMonthlyPut(requestParameters.id, requestParameters.target, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new dealsheet roll-off service
         * @summary Create a dealsheet roll-off service
         * @param {RollOffServicesApiCrmV1DealsheetRollOffServicesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1DealsheetRollOffServicesPost(requestParameters, options) {
            return localVarFp
                .crmV1DealsheetRollOffServicesPost(requestParameters.rollOffService, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * RollOffServicesApi - object-oriented interface
 */
export class RollOffServicesApi extends BaseAPI {
    /**
     * Get all dealsheet roll-off services with optional filtering and sorting
     * @summary List all dealsheet roll-off services
     * @param {RollOffServicesApiCrmV1DealsheetRollOffServicesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetRollOffServicesGet(requestParameters = {}, options) {
        return RollOffServicesApiFp(this.configuration)
            .crmV1DealsheetRollOffServicesGet(requestParameters.id, requestParameters.dealsheetID, requestParameters.siteID, requestParameters.siteIDWithRFP, requestParameters.rfpSiteID, requestParameters.withRates, requestParameters.sortBy, requestParameters.sortDir, requestParameters.limit, requestParameters.offset, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a dealsheet roll-off service by its ID
     * @summary Delete a dealsheet roll-off service
     * @param {RollOffServicesApiCrmV1DealsheetRollOffServicesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetRollOffServicesIdDelete(requestParameters, options) {
        return RollOffServicesApiFp(this.configuration)
            .crmV1DealsheetRollOffServicesIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a copy of an existing roll-off service including all order items with their values. The duplicated service will be on the same site as the source.
     * @summary Duplicate a roll-off service with all order items
     * @param {RollOffServicesApiCrmV1DealsheetRollOffServicesIdDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetRollOffServicesIdDuplicatePost(requestParameters, options) {
        return RollOffServicesApiFp(this.configuration)
            .crmV1DealsheetRollOffServicesIdDuplicatePost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing dealsheet roll-off service with the provided data
     * @summary Update a dealsheet roll-off service
     * @param {RollOffServicesApiCrmV1DealsheetRollOffServicesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetRollOffServicesIdPut(requestParameters, options) {
        return RollOffServicesApiFp(this.configuration)
            .crmV1DealsheetRollOffServicesIdPut(requestParameters.id, requestParameters.rollOffService, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Runs the roll-off rate formula backwards: given a target monthly rate, derives haul, dump and overage from the vendor\'s cost structure (or the incumbent\'s, before a vendor has quoted) and persists them. Roll-off has no single unit rate, so a target cannot be written to one column.
     * @summary Rebuild a roll-off line\'s rates to hit a monthly figure
     * @param {RollOffServicesApiCrmV1DealsheetRollOffServicesIdTargetMonthlyPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetRollOffServicesIdTargetMonthlyPut(requestParameters, options) {
        return RollOffServicesApiFp(this.configuration)
            .crmV1DealsheetRollOffServicesIdTargetMonthlyPut(requestParameters.id, requestParameters.target, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new dealsheet roll-off service
     * @summary Create a dealsheet roll-off service
     * @param {RollOffServicesApiCrmV1DealsheetRollOffServicesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1DealsheetRollOffServicesPost(requestParameters, options) {
        return RollOffServicesApiFp(this.configuration)
            .crmV1DealsheetRollOffServicesPost(requestParameters.rollOffService, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1DealsheetRollOffServicesGetWithRatesEnum = {
    True: 'true',
    False: 'false',
};
export const CrmV1DealsheetRollOffServicesGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * ServiceLocationsApi - axios parameter creator
 */
export const ServiceLocationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all service locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all service locations
         * @param {CrmV1ServiceLocationsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {string} [customerID] id of the customer which you want the service location for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1ServiceLocationsGet: async (sortDir, customerID, options = {}) => {
            const localVarPath = `/crm/v1/service-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (customerID !== undefined) {
                localVarQueryParameter['customerID'] = customerID;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing service location by its ID
         * @summary Delete a service location
         * @param {string} id Service Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1ServiceLocationsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1ServiceLocationsIdDelete', 'id', id);
            const localVarPath = `/crm/v1/service-locations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single service location by its ID
         * @summary Get a service location by ID
         * @param {string} id Service Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1ServiceLocationsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1ServiceLocationsIdGet', 'id', id);
            const localVarPath = `/crm/v1/service-locations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing service location with the provided data
         * @summary Update a service location
         * @param {string} id Service Location ID
         * @param {ModelServiceLocation} serviceLocation Service Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1ServiceLocationsIdPut: async (id, serviceLocation, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1ServiceLocationsIdPut', 'id', id);
            // verify required parameter 'serviceLocation' is not null or undefined
            assertParamExists('crmV1ServiceLocationsIdPut', 'serviceLocation', serviceLocation);
            const localVarPath = `/crm/v1/service-locations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLocation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new service location with the provided data
         * @summary Create a new service location
         * @param {ModelServiceLocation} serviceLocation Service Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1ServiceLocationsPost: async (serviceLocation, options = {}) => {
            // verify required parameter 'serviceLocation' is not null or undefined
            assertParamExists('crmV1ServiceLocationsPost', 'serviceLocation', serviceLocation);
            const localVarPath = `/crm/v1/service-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLocation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ServiceLocationsApi - functional programming interface
 */
export const ServiceLocationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ServiceLocationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all service locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all service locations
         * @param {CrmV1ServiceLocationsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {string} [customerID] id of the customer which you want the service location for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1ServiceLocationsGet(sortDir, customerID, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1ServiceLocationsGet(sortDir, customerID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.crmV1ServiceLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an existing service location by its ID
         * @summary Delete a service location
         * @param {string} id Service Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1ServiceLocationsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1ServiceLocationsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.crmV1ServiceLocationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single service location by its ID
         * @summary Get a service location by ID
         * @param {string} id Service Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1ServiceLocationsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1ServiceLocationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.crmV1ServiceLocationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing service location with the provided data
         * @summary Update a service location
         * @param {string} id Service Location ID
         * @param {ModelServiceLocation} serviceLocation Service Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1ServiceLocationsIdPut(id, serviceLocation, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1ServiceLocationsIdPut(id, serviceLocation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.crmV1ServiceLocationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new service location with the provided data
         * @summary Create a new service location
         * @param {ModelServiceLocation} serviceLocation Service Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1ServiceLocationsPost(serviceLocation, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1ServiceLocationsPost(serviceLocation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.crmV1ServiceLocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ServiceLocationsApi - factory interface
 */
export const ServiceLocationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ServiceLocationsApiFp(configuration);
    return {
        /**
         * Get all service locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all service locations
         * @param {ServiceLocationsApiCrmV1ServiceLocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1ServiceLocationsGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1ServiceLocationsGet(requestParameters.sortDir, requestParameters.customerID, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing service location by its ID
         * @summary Delete a service location
         * @param {ServiceLocationsApiCrmV1ServiceLocationsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1ServiceLocationsIdDelete(requestParameters, options) {
            return localVarFp.crmV1ServiceLocationsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single service location by its ID
         * @summary Get a service location by ID
         * @param {ServiceLocationsApiCrmV1ServiceLocationsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1ServiceLocationsIdGet(requestParameters, options) {
            return localVarFp.crmV1ServiceLocationsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing service location with the provided data
         * @summary Update a service location
         * @param {ServiceLocationsApiCrmV1ServiceLocationsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1ServiceLocationsIdPut(requestParameters, options) {
            return localVarFp
                .crmV1ServiceLocationsIdPut(requestParameters.id, requestParameters.serviceLocation, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new service location with the provided data
         * @summary Create a new service location
         * @param {ServiceLocationsApiCrmV1ServiceLocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1ServiceLocationsPost(requestParameters, options) {
            return localVarFp
                .crmV1ServiceLocationsPost(requestParameters.serviceLocation, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ServiceLocationsApi - object-oriented interface
 */
export class ServiceLocationsApi extends BaseAPI {
    /**
     * Get all service locations with optional filtering and sorting. Supports pagination and field filtering.
     * @summary List all service locations
     * @param {ServiceLocationsApiCrmV1ServiceLocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1ServiceLocationsGet(requestParameters = {}, options) {
        return ServiceLocationsApiFp(this.configuration)
            .crmV1ServiceLocationsGet(requestParameters.sortDir, requestParameters.customerID, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete an existing service location by its ID
     * @summary Delete a service location
     * @param {ServiceLocationsApiCrmV1ServiceLocationsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1ServiceLocationsIdDelete(requestParameters, options) {
        return ServiceLocationsApiFp(this.configuration)
            .crmV1ServiceLocationsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single service location by its ID
     * @summary Get a service location by ID
     * @param {ServiceLocationsApiCrmV1ServiceLocationsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1ServiceLocationsIdGet(requestParameters, options) {
        return ServiceLocationsApiFp(this.configuration)
            .crmV1ServiceLocationsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing service location with the provided data
     * @summary Update a service location
     * @param {ServiceLocationsApiCrmV1ServiceLocationsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1ServiceLocationsIdPut(requestParameters, options) {
        return ServiceLocationsApiFp(this.configuration)
            .crmV1ServiceLocationsIdPut(requestParameters.id, requestParameters.serviceLocation, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new service location with the provided data
     * @summary Create a new service location
     * @param {ServiceLocationsApiCrmV1ServiceLocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1ServiceLocationsPost(requestParameters, options) {
        return ServiceLocationsApiFp(this.configuration)
            .crmV1ServiceLocationsPost(requestParameters.serviceLocation, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1ServiceLocationsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * SitesApi - axios parameter creator
 */
export const SitesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all sites with optional filtering and sorting. When withCurrentDetails=true, returns WithCurrentDetails with currentPrice and currentVendorIDs fields.
         * @summary List all sites
         * @param {string} [id] Filter by site ID
         * @param {string} [orgID] Filter by org ID
         * @param {string} [customerID] Filter by customer ID
         * @param {string} [serviceLocationID] Filter by service location ID
         * @param {string} [status] Filter by status
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {CrmV1SitesGetWithCurrentDetailsEnum} [withCurrentDetails] Include calculated currentPrice and currentVendorIDs fields
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1SitesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesGet: async (id, orgID, customerID, serviceLocationID, status, dealsheetID, withCurrentDetails, sortBy, sortDir, options = {}) => {
            const localVarPath = `/crm/v1/sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (orgID !== undefined) {
                localVarQueryParameter['orgID'] = orgID;
            }
            if (customerID !== undefined) {
                localVarQueryParameter['customerID'] = customerID;
            }
            if (serviceLocationID !== undefined) {
                localVarQueryParameter['serviceLocationID'] = serviceLocationID;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (dealsheetID !== undefined) {
                localVarQueryParameter['dealsheetID'] = dealsheetID;
            }
            if (withCurrentDetails !== undefined) {
                localVarQueryParameter['withCurrentDetails'] = withCurrentDetails;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an existing site by its ID
         * @summary delete a site
         * @param {string} id Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1SitesIdDelete', 'id', id);
            const localVarPath = `/crm/v1/sites/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single site by its ID
         * @summary Get a site by ID
         * @param {string} id Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1SitesIdGet', 'id', id);
            const localVarPath = `/crm/v1/sites/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing site with the provided data
         * @summary update a site
         * @param {string} id Site ID
         * @param {CrmServiceDomainModelSite} site Site object
         * @param {boolean} [updateAllLocations] update all dealsheet sites locations, this only works if a site is part of a dealsheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesIdPut: async (id, site, updateAllLocations, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('crmV1SitesIdPut', 'id', id);
            // verify required parameter 'site' is not null or undefined
            assertParamExists('crmV1SitesIdPut', 'site', site);
            const localVarPath = `/crm/v1/sites/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (updateAllLocations !== undefined) {
                localVarQueryParameter['updateAllLocations'] = updateAllLocations;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(site, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new site with the provided data
         * @summary create a new site
         * @param {CrmServiceDomainModelSite} site Site object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesPost: async (site, options = {}) => {
            // verify required parameter 'site' is not null or undefined
            assertParamExists('crmV1SitesPost', 'site', site);
            const localVarPath = `/crm/v1/sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(site, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Drops and recreates the site index, then reindexes every site in the org. Cannot be scoped: the index is deleted first, so a partial reindex would leave the rest missing.
         * @summary Reindex all sites in Elasticsearch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesReindexPost: async (options = {}) => {
            const localVarPath = `/crm/v1/sites/reindex`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for sites by proxying an Elasticsearch query directly. Returns fully hydrated site objects.
         * @summary Search sites using Elasticsearch query (Search)
         * @param {SiteSearchRequest} search2Request Search request with Elasticsearch query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesSearch2Post: async (search2Request, options = {}) => {
            // verify required parameter 'search2Request' is not null or undefined
            assertParamExists('crmV1SitesSearch2Post', 'search2Request', search2Request);
            const localVarPath = `/crm/v1/sites/search2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(search2Request, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Merges a single section into the site\'s details JSON, leaving all other sections untouched. The merge is performed by the database, so concurrent edits to different sections do not overwrite one another. Send a null sectionData to clear a section.
         * @summary Update one section of a site\'s details
         * @param {string} siteId Site ID
         * @param {SiteUpdateDetailsSectionRequest} request Section to merge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesSiteIdDetailsPatch: async (siteId, request, options = {}) => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('crmV1SitesSiteIdDetailsPatch', 'siteId', siteId);
            // verify required parameter 'request' is not null or undefined
            assertParamExists('crmV1SitesSiteIdDetailsPatch', 'request', request);
            const localVarPath = `/crm/v1/sites/{siteId}/details`.replace('{siteId}', encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new RFP and rfp_site with LOA status (recommended=true), duplicates existing services, sets site.status=LOA, creates or updates the LOA_FEE order item
         * @summary Mark a site as LOA
         * @param {string} siteId Site ID
         * @param {SiteMarkLoaRequest} body Mark LOA request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesSiteIdMarkLoaPost: async (siteId, body, options = {}) => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('crmV1SitesSiteIdMarkLoaPost', 'siteId', siteId);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('crmV1SitesSiteIdMarkLoaPost', 'body', body);
            const localVarPath = `/crm/v1/sites/{siteId}/mark-loa`.replace('{siteId}', encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Atomically deletes the recommended rfp_site (cascade: services, parent RFP if empty), removes the LOA_FEE order item, and sets site status to READY_TO_QUOTE
         * @summary Remove LOA from a site
         * @param {string} siteId Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesSiteIdRemoveLoaPost: async (siteId, options = {}) => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('crmV1SitesSiteIdRemoveLoaPost', 'siteId', siteId);
            const localVarPath = `/crm/v1/sites/{siteId}/remove-loa`.replace('{siteId}', encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SitesApi - functional programming interface
 */
export const SitesApiFp = function (configuration) {
    const localVarAxiosParamCreator = SitesApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all sites with optional filtering and sorting. When withCurrentDetails=true, returns WithCurrentDetails with currentPrice and currentVendorIDs fields.
         * @summary List all sites
         * @param {string} [id] Filter by site ID
         * @param {string} [orgID] Filter by org ID
         * @param {string} [customerID] Filter by customer ID
         * @param {string} [serviceLocationID] Filter by service location ID
         * @param {string} [status] Filter by status
         * @param {string} [dealsheetID] Filter by dealsheet ID
         * @param {CrmV1SitesGetWithCurrentDetailsEnum} [withCurrentDetails] Include calculated currentPrice and currentVendorIDs fields
         * @param {string} [sortBy] Sort by field
         * @param {CrmV1SitesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1SitesGet(id, orgID, customerID, serviceLocationID, status, dealsheetID, withCurrentDetails, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1SitesGet(id, orgID, customerID, serviceLocationID, status, dealsheetID, withCurrentDetails, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.crmV1SitesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete an existing site by its ID
         * @summary delete a site
         * @param {string} id Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1SitesIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1SitesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.crmV1SitesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single site by its ID
         * @summary Get a site by ID
         * @param {string} id Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1SitesIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1SitesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.crmV1SitesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing site with the provided data
         * @summary update a site
         * @param {string} id Site ID
         * @param {CrmServiceDomainModelSite} site Site object
         * @param {boolean} [updateAllLocations] update all dealsheet sites locations, this only works if a site is part of a dealsheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1SitesIdPut(id, site, updateAllLocations, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1SitesIdPut(id, site, updateAllLocations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.crmV1SitesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new site with the provided data
         * @summary create a new site
         * @param {CrmServiceDomainModelSite} site Site object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1SitesPost(site, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1SitesPost(site, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.crmV1SitesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Drops and recreates the site index, then reindexes every site in the org. Cannot be scoped: the index is deleted first, so a partial reindex would leave the rest missing.
         * @summary Reindex all sites in Elasticsearch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1SitesReindexPost(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1SitesReindexPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.crmV1SitesReindexPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for sites by proxying an Elasticsearch query directly. Returns fully hydrated site objects.
         * @summary Search sites using Elasticsearch query (Search)
         * @param {SiteSearchRequest} search2Request Search request with Elasticsearch query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1SitesSearch2Post(search2Request, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1SitesSearch2Post(search2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.crmV1SitesSearch2Post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Merges a single section into the site\'s details JSON, leaving all other sections untouched. The merge is performed by the database, so concurrent edits to different sections do not overwrite one another. Send a null sectionData to clear a section.
         * @summary Update one section of a site\'s details
         * @param {string} siteId Site ID
         * @param {SiteUpdateDetailsSectionRequest} request Section to merge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1SitesSiteIdDetailsPatch(siteId, request, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1SitesSiteIdDetailsPatch(siteId, request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.crmV1SitesSiteIdDetailsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new RFP and rfp_site with LOA status (recommended=true), duplicates existing services, sets site.status=LOA, creates or updates the LOA_FEE order item
         * @summary Mark a site as LOA
         * @param {string} siteId Site ID
         * @param {SiteMarkLoaRequest} body Mark LOA request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1SitesSiteIdMarkLoaPost(siteId, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1SitesSiteIdMarkLoaPost(siteId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.crmV1SitesSiteIdMarkLoaPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Atomically deletes the recommended rfp_site (cascade: services, parent RFP if empty), removes the LOA_FEE order item, and sets site status to READY_TO_QUOTE
         * @summary Remove LOA from a site
         * @param {string} siteId Site ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmV1SitesSiteIdRemoveLoaPost(siteId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmV1SitesSiteIdRemoveLoaPost(siteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.crmV1SitesSiteIdRemoveLoaPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SitesApi - factory interface
 */
export const SitesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SitesApiFp(configuration);
    return {
        /**
         * Get all sites with optional filtering and sorting. When withCurrentDetails=true, returns WithCurrentDetails with currentPrice and currentVendorIDs fields.
         * @summary List all sites
         * @param {SitesApiCrmV1SitesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesGet(requestParameters = {}, options) {
            return localVarFp
                .crmV1SitesGet(requestParameters.id, requestParameters.orgID, requestParameters.customerID, requestParameters.serviceLocationID, requestParameters.status, requestParameters.dealsheetID, requestParameters.withCurrentDetails, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * delete an existing site by its ID
         * @summary delete a site
         * @param {SitesApiCrmV1SitesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesIdDelete(requestParameters, options) {
            return localVarFp.crmV1SitesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single site by its ID
         * @summary Get a site by ID
         * @param {SitesApiCrmV1SitesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesIdGet(requestParameters, options) {
            return localVarFp.crmV1SitesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing site with the provided data
         * @summary update a site
         * @param {SitesApiCrmV1SitesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesIdPut(requestParameters, options) {
            return localVarFp
                .crmV1SitesIdPut(requestParameters.id, requestParameters.site, requestParameters.updateAllLocations, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new site with the provided data
         * @summary create a new site
         * @param {SitesApiCrmV1SitesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesPost(requestParameters, options) {
            return localVarFp.crmV1SitesPost(requestParameters.site, options).then((request) => request(axios, basePath));
        },
        /**
         * Drops and recreates the site index, then reindexes every site in the org. Cannot be scoped: the index is deleted first, so a partial reindex would leave the rest missing.
         * @summary Reindex all sites in Elasticsearch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesReindexPost(options) {
            return localVarFp.crmV1SitesReindexPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Search for sites by proxying an Elasticsearch query directly. Returns fully hydrated site objects.
         * @summary Search sites using Elasticsearch query (Search)
         * @param {SitesApiCrmV1SitesSearch2PostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesSearch2Post(requestParameters, options) {
            return localVarFp.crmV1SitesSearch2Post(requestParameters.search2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Merges a single section into the site\'s details JSON, leaving all other sections untouched. The merge is performed by the database, so concurrent edits to different sections do not overwrite one another. Send a null sectionData to clear a section.
         * @summary Update one section of a site\'s details
         * @param {SitesApiCrmV1SitesSiteIdDetailsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesSiteIdDetailsPatch(requestParameters, options) {
            return localVarFp
                .crmV1SitesSiteIdDetailsPatch(requestParameters.siteId, requestParameters.request, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Creates a new RFP and rfp_site with LOA status (recommended=true), duplicates existing services, sets site.status=LOA, creates or updates the LOA_FEE order item
         * @summary Mark a site as LOA
         * @param {SitesApiCrmV1SitesSiteIdMarkLoaPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesSiteIdMarkLoaPost(requestParameters, options) {
            return localVarFp
                .crmV1SitesSiteIdMarkLoaPost(requestParameters.siteId, requestParameters.body, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Atomically deletes the recommended rfp_site (cascade: services, parent RFP if empty), removes the LOA_FEE order item, and sets site status to READY_TO_QUOTE
         * @summary Remove LOA from a site
         * @param {SitesApiCrmV1SitesSiteIdRemoveLoaPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmV1SitesSiteIdRemoveLoaPost(requestParameters, options) {
            return localVarFp.crmV1SitesSiteIdRemoveLoaPost(requestParameters.siteId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SitesApi - object-oriented interface
 */
export class SitesApi extends BaseAPI {
    /**
     * Get all sites with optional filtering and sorting. When withCurrentDetails=true, returns WithCurrentDetails with currentPrice and currentVendorIDs fields.
     * @summary List all sites
     * @param {SitesApiCrmV1SitesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1SitesGet(requestParameters = {}, options) {
        return SitesApiFp(this.configuration)
            .crmV1SitesGet(requestParameters.id, requestParameters.orgID, requestParameters.customerID, requestParameters.serviceLocationID, requestParameters.status, requestParameters.dealsheetID, requestParameters.withCurrentDetails, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete an existing site by its ID
     * @summary delete a site
     * @param {SitesApiCrmV1SitesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1SitesIdDelete(requestParameters, options) {
        return SitesApiFp(this.configuration)
            .crmV1SitesIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single site by its ID
     * @summary Get a site by ID
     * @param {SitesApiCrmV1SitesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1SitesIdGet(requestParameters, options) {
        return SitesApiFp(this.configuration)
            .crmV1SitesIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing site with the provided data
     * @summary update a site
     * @param {SitesApiCrmV1SitesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1SitesIdPut(requestParameters, options) {
        return SitesApiFp(this.configuration)
            .crmV1SitesIdPut(requestParameters.id, requestParameters.site, requestParameters.updateAllLocations, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new site with the provided data
     * @summary create a new site
     * @param {SitesApiCrmV1SitesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1SitesPost(requestParameters, options) {
        return SitesApiFp(this.configuration)
            .crmV1SitesPost(requestParameters.site, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Drops and recreates the site index, then reindexes every site in the org. Cannot be scoped: the index is deleted first, so a partial reindex would leave the rest missing.
     * @summary Reindex all sites in Elasticsearch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1SitesReindexPost(options) {
        return SitesApiFp(this.configuration)
            .crmV1SitesReindexPost(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for sites by proxying an Elasticsearch query directly. Returns fully hydrated site objects.
     * @summary Search sites using Elasticsearch query (Search)
     * @param {SitesApiCrmV1SitesSearch2PostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1SitesSearch2Post(requestParameters, options) {
        return SitesApiFp(this.configuration)
            .crmV1SitesSearch2Post(requestParameters.search2Request, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Merges a single section into the site\'s details JSON, leaving all other sections untouched. The merge is performed by the database, so concurrent edits to different sections do not overwrite one another. Send a null sectionData to clear a section.
     * @summary Update one section of a site\'s details
     * @param {SitesApiCrmV1SitesSiteIdDetailsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1SitesSiteIdDetailsPatch(requestParameters, options) {
        return SitesApiFp(this.configuration)
            .crmV1SitesSiteIdDetailsPatch(requestParameters.siteId, requestParameters.request, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new RFP and rfp_site with LOA status (recommended=true), duplicates existing services, sets site.status=LOA, creates or updates the LOA_FEE order item
     * @summary Mark a site as LOA
     * @param {SitesApiCrmV1SitesSiteIdMarkLoaPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1SitesSiteIdMarkLoaPost(requestParameters, options) {
        return SitesApiFp(this.configuration)
            .crmV1SitesSiteIdMarkLoaPost(requestParameters.siteId, requestParameters.body, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Atomically deletes the recommended rfp_site (cascade: services, parent RFP if empty), removes the LOA_FEE order item, and sets site status to READY_TO_QUOTE
     * @summary Remove LOA from a site
     * @param {SitesApiCrmV1SitesSiteIdRemoveLoaPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crmV1SitesSiteIdRemoveLoaPost(requestParameters, options) {
        return SitesApiFp(this.configuration)
            .crmV1SitesSiteIdRemoveLoaPost(requestParameters.siteId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const CrmV1SitesGetWithCurrentDetailsEnum = {
    True: 'true',
    False: 'false',
};
export const CrmV1SitesGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
